/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.0.3.0 (NJsonSchema v10.0.21.0 (Newtonsoft.Json v10.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import * as moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAccountClient {
    getPnLInTimeRange(accountId?: number | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined): Observable<AccountOrderDataSumResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getPnLInTimeRange(accountId?: number | undefined, startDate?: moment.Moment | undefined, endDate?: moment.Moment | undefined): Observable<AccountOrderDataSumResponse> {
        let url_ = this.baseUrl + "/GetPnLInTimeRange?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        if (startDate === null)
            throw new Error("The parameter 'startDate' cannot be null.");
        else if (startDate !== undefined)
            url_ += "startDate=" + encodeURIComponent(startDate ? "" + startDate.toJSON() : "") + "&"; 
        if (endDate === null)
            throw new Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toJSON() : "") + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPnLInTimeRange(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPnLInTimeRange(<any>response_);
                } catch (e) {
                    return <Observable<AccountOrderDataSumResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<AccountOrderDataSumResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetPnLInTimeRange(response: HttpResponseBase): Observable<AccountOrderDataSumResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountOrderDataSumResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountOrderDataSumResponse>(<any>null);
    }
}

export interface IAccountsClient {
    getAllByEmail(email?: string | null | undefined): Observable<Account[]>;
    addNewAccount(email?: string | null | undefined, accountName?: string | null | undefined, balance?: number | undefined): Observable<number>;
    addNewAccountForExistedUser(userId?: number | undefined, accountName?: string | null | undefined, balance?: number | undefined): Observable<number>;
    editAccountForExistedUser(accountId?: number | undefined, newAccountName?: string | null | undefined): Observable<number>;
    deleteAccountByAccountId(accountId?: number | undefined): Observable<number>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountsClient implements IAccountsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAllByEmail(email?: string | null | undefined): Observable<Account[]> {
        let url_ = this.baseUrl + "/api/Accounts/GetAllByEmail?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByEmail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByEmail(<any>response_);
                } catch (e) {
                    return <Observable<Account[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Account[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllByEmail(response: HttpResponseBase): Observable<Account[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Account.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Account[]>(<any>null);
    }

    addNewAccount(email?: string | null | undefined, accountName?: string | null | undefined, balance?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Accounts/AddNewAccount?";
        if (email !== undefined)
            url_ += "email=" + encodeURIComponent("" + email) + "&"; 
        if (accountName !== undefined)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&"; 
        if (balance === null)
            throw new Error("The parameter 'balance' cannot be null.");
        else if (balance !== undefined)
            url_ += "Balance=" + encodeURIComponent("" + balance) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewAccount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAddNewAccount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    addNewAccountForExistedUser(userId?: number | undefined, accountName?: string | null | undefined, balance?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Accounts/AddNewAccountForExistedUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (accountName !== undefined)
            url_ += "accountName=" + encodeURIComponent("" + accountName) + "&"; 
        if (balance === null)
            throw new Error("The parameter 'balance' cannot be null.");
        else if (balance !== undefined)
            url_ += "Balance=" + encodeURIComponent("" + balance) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddNewAccountForExistedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddNewAccountForExistedUser(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processAddNewAccountForExistedUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    editAccountForExistedUser(accountId?: number | undefined, newAccountName?: string | null | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Accounts/editAccountForExistedUser?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        if (newAccountName !== undefined)
            url_ += "newAccountName=" + encodeURIComponent("" + newAccountName) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEditAccountForExistedUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEditAccountForExistedUser(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processEditAccountForExistedUser(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    deleteAccountByAccountId(accountId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Accounts/deleteAccountByAccountId?";
        if (accountId === null)
            throw new Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccountByAccountId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccountByAccountId(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteAccountByAccountId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }
}

export interface IAppStoreClient {
    addRating(userId?: number | undefined, productId?: number | undefined, rate?: number | undefined): Observable<boolean>;
    getRating(productId?: number | undefined): Observable<number>;
    checkUserSetRating(productId?: number | undefined, userId?: number | undefined): Observable<number>;
    getRatingsCount(productId?: number | undefined): Observable<number>;
    getInfo(): Observable<AppStoreInfoModel>;
    getUserActiveProducts(userId?: number | undefined): Observable<GetUserActiveProductsRes>;
    startTrial(productId?: number | undefined, userId?: number | undefined): Observable<StartTrialResponseModel>;
    createOrUpdateOrder(data: CheckoutData): Observable<OrderResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AppStoreClient implements IAppStoreClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    addRating(userId?: number | undefined, productId?: number | undefined, rate?: number | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/AppStore/AddRating?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (rate === null)
            throw new Error("The parameter 'rate' cannot be null.");
        else if (rate !== undefined)
            url_ += "rate=" + encodeURIComponent("" + rate) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddRating(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddRating(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    getRating(productId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/AppStore/GetRating?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRating(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetRating(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    checkUserSetRating(productId?: number | undefined, userId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/AppStore/CheckUserSetRating?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckUserSetRating(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckUserSetRating(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processCheckUserSetRating(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    getRatingsCount(productId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/AppStore/GetRatingsCount?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRatingsCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRatingsCount(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processGetRatingsCount(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    getInfo(): Observable<AppStoreInfoModel> {
        let url_ = this.baseUrl + "/api/AppStore/GetInfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInfo(<any>response_);
                } catch (e) {
                    return <Observable<AppStoreInfoModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<AppStoreInfoModel>><any>_observableThrow(response_);
        }));
    }

    protected processGetInfo(response: HttpResponseBase): Observable<AppStoreInfoModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AppStoreInfoModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AppStoreInfoModel>(<any>null);
    }

    getUserActiveProducts(userId?: number | undefined): Observable<GetUserActiveProductsRes> {
        let url_ = this.baseUrl + "/api/AppStore/GetUserActiveProducts?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserActiveProducts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserActiveProducts(<any>response_);
                } catch (e) {
                    return <Observable<GetUserActiveProductsRes>><any>_observableThrow(e);
                }
            } else
                return <Observable<GetUserActiveProductsRes>><any>_observableThrow(response_);
        }));
    }

    protected processGetUserActiveProducts(response: HttpResponseBase): Observable<GetUserActiveProductsRes> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserActiveProductsRes.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserActiveProductsRes>(<any>null);
    }

    startTrial(productId?: number | undefined, userId?: number | undefined): Observable<StartTrialResponseModel> {
        let url_ = this.baseUrl + "/api/AppStore/StartTrial?";
        if (productId === null)
            throw new Error("The parameter 'productId' cannot be null.");
        else if (productId !== undefined)
            url_ += "productId=" + encodeURIComponent("" + productId) + "&"; 
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processStartTrial(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processStartTrial(<any>response_);
                } catch (e) {
                    return <Observable<StartTrialResponseModel>><any>_observableThrow(e);
                }
            } else
                return <Observable<StartTrialResponseModel>><any>_observableThrow(response_);
        }));
    }

    protected processStartTrial(response: HttpResponseBase): Observable<StartTrialResponseModel> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = StartTrialResponseModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<StartTrialResponseModel>(<any>null);
    }

    createOrUpdateOrder(data: CheckoutData): Observable<OrderResult> {
        let url_ = this.baseUrl + "/api/AppStore/CreateOrUpdateOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(data);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateOrUpdateOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateOrUpdateOrder(<any>response_);
                } catch (e) {
                    return <Observable<OrderResult>><any>_observableThrow(e);
                }
            } else
                return <Observable<OrderResult>><any>_observableThrow(response_);
        }));
    }

    protected processCreateOrUpdateOrder(response: HttpResponseBase): Observable<OrderResult> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OrderResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<OrderResult>(<any>null);
    }
}

export interface IHomeClient {
    preloader(uid?: string | null | undefined, targetUrl?: string | null | undefined): Observable<FileResponse | null>;
    preview(uid: string | null): Observable<FileResponse | null>;
    adveristment(): Observable<Adveristment[]>;
    createUserAndRegisterToChallenge(inf_field_FirstName?: string | null | undefined, inf_field_LastName?: string | null | undefined, inf_field_Email?: string | null | undefined, inf_field_Phone1?: string | null | undefined, inf_field_Country4?: string | null | undefined, inf_custom_TradingExperience?: string | null | undefined, inf_custom_PTPassword?: string | null | undefined, dixToken?: string | null | undefined, isChallenge?: string | null | undefined, tagsToApply?: string | null | undefined): Observable<FileResponse | null>;
    createTokenByCode(code?: string | null | undefined, scope?: string | null | undefined, state?: string | null | undefined): Observable<InfusionToken>;
}

@Injectable({
    providedIn: 'root'
})
export class HomeClient implements IHomeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    preloader(uid?: string | null | undefined, targetUrl?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Preloader?";
        if (uid !== undefined)
            url_ += "uid=" + encodeURIComponent("" + uid) + "&"; 
        if (targetUrl !== undefined)
            url_ += "targetUrl=" + encodeURIComponent("" + targetUrl) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreloader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreloader(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPreloader(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    preview(uid: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/Preview/{uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPreview(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processPreview(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    adveristment(): Observable<Adveristment[]> {
        let url_ = this.baseUrl + "/Adveristment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdveristment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdveristment(<any>response_);
                } catch (e) {
                    return <Observable<Adveristment[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Adveristment[]>><any>_observableThrow(response_);
        }));
    }

    protected processAdveristment(response: HttpResponseBase): Observable<Adveristment[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Adveristment.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Adveristment[]>(<any>null);
    }

    createUserAndRegisterToChallenge(inf_field_FirstName?: string | null | undefined, inf_field_LastName?: string | null | undefined, inf_field_Email?: string | null | undefined, inf_field_Phone1?: string | null | undefined, inf_field_Country4?: string | null | undefined, inf_custom_TradingExperience?: string | null | undefined, inf_custom_PTPassword?: string | null | undefined, dixToken?: string | null | undefined, isChallenge?: string | null | undefined, tagsToApply?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/CreateUserAndRegisterToChallenge?";
        if (inf_field_FirstName !== undefined)
            url_ += "inf_field_FirstName=" + encodeURIComponent("" + inf_field_FirstName) + "&"; 
        if (inf_field_LastName !== undefined)
            url_ += "inf_field_LastName=" + encodeURIComponent("" + inf_field_LastName) + "&"; 
        if (inf_field_Email !== undefined)
            url_ += "inf_field_Email=" + encodeURIComponent("" + inf_field_Email) + "&"; 
        if (inf_field_Phone1 !== undefined)
            url_ += "inf_field_Phone1=" + encodeURIComponent("" + inf_field_Phone1) + "&"; 
        if (inf_field_Country4 !== undefined)
            url_ += "inf_field_Country4=" + encodeURIComponent("" + inf_field_Country4) + "&"; 
        if (inf_custom_TradingExperience !== undefined)
            url_ += "inf_custom_TradingExperience=" + encodeURIComponent("" + inf_custom_TradingExperience) + "&"; 
        if (inf_custom_PTPassword !== undefined)
            url_ += "inf_custom_PTPassword=" + encodeURIComponent("" + inf_custom_PTPassword) + "&"; 
        if (dixToken !== undefined)
            url_ += "dixToken=" + encodeURIComponent("" + dixToken) + "&"; 
        if (isChallenge !== undefined)
            url_ += "isChallenge=" + encodeURIComponent("" + isChallenge) + "&"; 
        if (tagsToApply !== undefined)
            url_ += "TagsToApply=" + encodeURIComponent("" + tagsToApply) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUserAndRegisterToChallenge(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUserAndRegisterToChallenge(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processCreateUserAndRegisterToChallenge(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    createTokenByCode(code?: string | null | undefined, scope?: string | null | undefined, state?: string | null | undefined): Observable<InfusionToken> {
        let url_ = this.baseUrl + "/CreateTokenByCode?";
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        if (scope !== undefined)
            url_ += "scope=" + encodeURIComponent("" + scope) + "&"; 
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateTokenByCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateTokenByCode(<any>response_);
                } catch (e) {
                    return <Observable<InfusionToken>><any>_observableThrow(e);
                }
            } else
                return <Observable<InfusionToken>><any>_observableThrow(response_);
        }));
    }

    protected processCreateTokenByCode(response: HttpResponseBase): Observable<InfusionToken> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InfusionToken.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<InfusionToken>(<any>null);
    }
}

export interface IOauthClient {
    getAccounts(): Observable<TradingProvider[]>;
    oAuthRequest(provider?: string | null | undefined, sessionKey?: string | null | undefined): Observable<FileResponse | null>;
    authorize(state?: string | null | undefined, code?: string | null | undefined): Observable<FileResponse | null>;
}

@Injectable({
    providedIn: 'root'
})
export class OauthClient implements IOauthClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAccounts(): Observable<TradingProvider[]> {
        let url_ = this.baseUrl + "/api/Oauth/accounts";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccounts(<any>response_);
                } catch (e) {
                    return <Observable<TradingProvider[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TradingProvider[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAccounts(response: HttpResponseBase): Observable<TradingProvider[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TradingProvider.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TradingProvider[]>(<any>null);
    }

    oAuthRequest(provider?: string | null | undefined, sessionKey?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Oauth/request?";
        if (provider !== undefined)
            url_ += "provider=" + encodeURIComponent("" + provider) + "&"; 
        if (sessionKey !== undefined)
            url_ += "sessionKey=" + encodeURIComponent("" + sessionKey) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processOAuthRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processOAuthRequest(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processOAuthRequest(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    authorize(state?: string | null | undefined, code?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Oauth/authorize?";
        if (state !== undefined)
            url_ += "state=" + encodeURIComponent("" + state) + "&"; 
        if (code !== undefined)
            url_ += "code=" + encodeURIComponent("" + code) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAuthorize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAuthorize(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processAuthorize(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }
}

export interface IServicesClient {
    groupedRequest(groupedRq: GroupedRqWithSessionKey): Observable<Stream>;
}

@Injectable({
    providedIn: 'root'
})
export class ServicesClient implements IServicesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    groupedRequest(groupedRq: GroupedRqWithSessionKey): Observable<Stream> {
        let url_ = this.baseUrl + "/api/Services/GroupedRequestAsync";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(groupedRq);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json", 
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGroupedRequest(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGroupedRequest(<any>response_);
                } catch (e) {
                    return <Observable<Stream>><any>_observableThrow(e);
                }
            } else
                return <Observable<Stream>><any>_observableThrow(response_);
        }));
    }

    protected processGroupedRequest(response: HttpResponseBase): Observable<Stream> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Stream.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Stream>(<any>null);
    }
}

export interface ISettingsClient {
    save(userName?: string | null | undefined, jsonSettingsArray?: string | null | undefined): Observable<FileResponse | null>;
    getGainAppKey(): Observable<GainSettingsRs>;
    get(userName?: string | null | undefined, key?: string | null | undefined): Observable<Setting>;
    getAll(userName?: string | null | undefined, keys?: string[] | null | undefined): Observable<Setting[]>;
    getAllFromSet(userName?: string | null | undefined, userSet?: string | null | undefined): Observable<Setting[]>;
    getProviders(userId?: number | undefined): Observable<UserTradingProvider[]>;
    addProviderLoginData(userId?: number | undefined, providerId?: string | null | undefined, userName?: string | null | undefined, userPassword?: string | null | undefined): Observable<boolean>;
    updateProviderLoginData(userId?: number | undefined, userName?: string | null | undefined, userPassword?: string | null | undefined, providerId?: string | null | undefined): Observable<boolean>;
}

@Injectable({
    providedIn: 'root'
})
export class SettingsClient implements ISettingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    save(userName?: string | null | undefined, jsonSettingsArray?: string | null | undefined): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/Settings/Save";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (userName !== null && userName !== undefined)
            content_.append("userName", userName.toString());
        if (jsonSettingsArray !== null && jsonSettingsArray !== undefined)
            content_.append("jsonSettingsArray", jsonSettingsArray.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSave(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSave(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processSave(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getGainAppKey(): Observable<GainSettingsRs> {
        let url_ = this.baseUrl + "/api/Settings/GetGainAppKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGainAppKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGainAppKey(<any>response_);
                } catch (e) {
                    return <Observable<GainSettingsRs>><any>_observableThrow(e);
                }
            } else
                return <Observable<GainSettingsRs>><any>_observableThrow(response_);
        }));
    }

    protected processGetGainAppKey(response: HttpResponseBase): Observable<GainSettingsRs> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GainSettingsRs.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GainSettingsRs>(<any>null);
    }

    get(userName?: string | null | undefined, key?: string | null | undefined): Observable<Setting> {
        let url_ = this.baseUrl + "/api/Settings/Get?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (key !== undefined)
            url_ += "key=" + encodeURIComponent("" + key) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(<any>response_);
                } catch (e) {
                    return <Observable<Setting>><any>_observableThrow(e);
                }
            } else
                return <Observable<Setting>><any>_observableThrow(response_);
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<Setting> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = Setting.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Setting>(<any>null);
    }

    getAll(userName?: string | null | undefined, keys?: string[] | null | undefined): Observable<Setting[]> {
        let url_ = this.baseUrl + "/api/Settings/GetAll?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (keys !== undefined)
            keys && keys.forEach(item => { url_ += "keys=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<Setting[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Setting[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<Setting[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Setting.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Setting[]>(<any>null);
    }

    getAllFromSet(userName?: string | null | undefined, userSet?: string | null | undefined): Observable<Setting[]> {
        let url_ = this.baseUrl + "/api/Settings/GetAllFromSet?";
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (userSet !== undefined)
            url_ += "userSet=" + encodeURIComponent("" + userSet) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllFromSet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllFromSet(<any>response_);
                } catch (e) {
                    return <Observable<Setting[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<Setting[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllFromSet(response: HttpResponseBase): Observable<Setting[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(Setting.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<Setting[]>(<any>null);
    }

    getProviders(userId?: number | undefined): Observable<UserTradingProvider[]> {
        let url_ = this.baseUrl + "/api/Settings/GetProviders?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProviders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProviders(<any>response_);
                } catch (e) {
                    return <Observable<UserTradingProvider[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserTradingProvider[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetProviders(response: HttpResponseBase): Observable<UserTradingProvider[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserTradingProvider.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserTradingProvider[]>(<any>null);
    }

    addProviderLoginData(userId?: number | undefined, providerId?: string | null | undefined, userName?: string | null | undefined, userPassword?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/AddProviderLoginData?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (providerId !== undefined)
            url_ += "providerId=" + encodeURIComponent("" + providerId) + "&"; 
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (userPassword !== undefined)
            url_ += "userPassword=" + encodeURIComponent("" + userPassword) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddProviderLoginData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddProviderLoginData(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processAddProviderLoginData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    updateProviderLoginData(userId?: number | undefined, userName?: string | null | undefined, userPassword?: string | null | undefined, providerId?: string | null | undefined): Observable<boolean> {
        let url_ = this.baseUrl + "/api/Settings/UpdateProviderLoginData?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (userName !== undefined)
            url_ += "userName=" + encodeURIComponent("" + userName) + "&"; 
        if (userPassword !== undefined)
            url_ += "userPassword=" + encodeURIComponent("" + userPassword) + "&"; 
        if (providerId !== undefined)
            url_ += "providerId=" + encodeURIComponent("" + providerId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateProviderLoginData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateProviderLoginData(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processUpdateProviderLoginData(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }
}

export interface ISharedContentClient {
    checkSocialPostExists(uid: string | null): Observable<boolean>;
    image(uid: string | null): Observable<FileResponse | null>;
    getLatestUserPostByProvider(email: string | null, provider: string | null): Observable<SharedContent>;
    createSocialPostWithSvg(uid?: string | null | undefined, provider?: string | null | undefined, text?: string | null | undefined, email?: string | null | undefined, svg?: string | null | undefined, targetFormat?: string | null | undefined, targetQuality?: number | undefined): Observable<string>;
}

@Injectable({
    providedIn: 'root'
})
export class SharedContentClient implements ISharedContentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    checkSocialPostExists(uid: string | null): Observable<boolean> {
        let url_ = this.baseUrl + "/api/SharedContent/CheckSocialPostExists/{uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckSocialPostExists(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckSocialPostExists(<any>response_);
                } catch (e) {
                    return <Observable<boolean>><any>_observableThrow(e);
                }
            } else
                return <Observable<boolean>><any>_observableThrow(response_);
        }));
    }

    protected processCheckSocialPostExists(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<boolean>(<any>null);
    }

    image(uid: string | null): Observable<FileResponse | null> {
        let url_ = this.baseUrl + "/api/SharedContent/Image/{uid}";
        if (uid === undefined || uid === null)
            throw new Error("The parameter 'uid' must be defined.");
        url_ = url_.replace("{uid}", encodeURIComponent("" + uid)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImage(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImage(<any>response_);
                } catch (e) {
                    return <Observable<FileResponse | null>><any>_observableThrow(e);
                }
            } else
                return <Observable<FileResponse | null>><any>_observableThrow(response_);
        }));
    }

    protected processImage(response: HttpResponseBase): Observable<FileResponse | null> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return _observableOf({ fileName: fileName, data: <any>responseBlob, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse | null>(<any>null);
    }

    getLatestUserPostByProvider(email: string | null, provider: string | null): Observable<SharedContent> {
        let url_ = this.baseUrl + "/api/SharedContent/GetLatestUserPostByProvider/{email}/{provider}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email)); 
        if (provider === undefined || provider === null)
            throw new Error("The parameter 'provider' must be defined.");
        url_ = url_.replace("{provider}", encodeURIComponent("" + provider)); 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetLatestUserPostByProvider(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetLatestUserPostByProvider(<any>response_);
                } catch (e) {
                    return <Observable<SharedContent>><any>_observableThrow(e);
                }
            } else
                return <Observable<SharedContent>><any>_observableThrow(response_);
        }));
    }

    protected processGetLatestUserPostByProvider(response: HttpResponseBase): Observable<SharedContent> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SharedContent.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SharedContent>(<any>null);
    }

    createSocialPostWithSvg(uid?: string | null | undefined, provider?: string | null | undefined, text?: string | null | undefined, email?: string | null | undefined, svg?: string | null | undefined, targetFormat?: string | null | undefined, targetQuality?: number | undefined): Observable<string> {
        let url_ = this.baseUrl + "/api/SharedContent/CreateSocialPostWithSvg";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (uid !== null && uid !== undefined)
            content_.append("uid", uid.toString());
        if (provider !== null && provider !== undefined)
            content_.append("provider", provider.toString());
        if (text !== null && text !== undefined)
            content_.append("text", text.toString());
        if (email !== null && email !== undefined)
            content_.append("email", email.toString());
        if (svg !== null && svg !== undefined)
            content_.append("svg", svg.toString());
        if (targetFormat !== null && targetFormat !== undefined)
            content_.append("targetFormat", targetFormat.toString());
        if (targetQuality === null || targetQuality === undefined)
            throw new Error("The parameter 'targetQuality' cannot be null.");
        else
            content_.append("targetQuality", targetQuality.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateSocialPostWithSvg(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateSocialPostWithSvg(<any>response_);
                } catch (e) {
                    return <Observable<string>><any>_observableThrow(e);
                }
            } else
                return <Observable<string>><any>_observableThrow(response_);
        }));
    }

    protected processCreateSocialPostWithSvg(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<string>(<any>null);
    }
}

export interface ITournamentClient {
    getAll(): Observable<TournamentWithAccountId[]>;
    getTournamentsForUser(userId?: number | undefined): Observable<UserTournamentsResponse>;
    getTournamentLeaderboard(tournamentId?: number | undefined): Observable<LeaderBoardResponse>;
    deleteTournamentUserByIds(userId?: number | undefined, tournamentId?: number | undefined): Observable<number>;
    wasFirstLoginUserByIds(userId?: number | undefined, tournamentId?: number | undefined, wasLogin?: number | undefined): Observable<number>;
    getlogisState(userId?: number | undefined, tournamentId?: number | undefined): Observable<TournamentUserAndAccount[]>;
    getAllTournamentsForUser(userId?: number | undefined): Observable<TournamentUserAndAccount[]>;
}

@Injectable({
    providedIn: 'root'
})
export class TournamentClient implements ITournamentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : "";
    }

    getAll(): Observable<TournamentWithAccountId[]> {
        let url_ = this.baseUrl + "/api/Tournament/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(<any>response_);
                } catch (e) {
                    return <Observable<TournamentWithAccountId[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TournamentWithAccountId[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<TournamentWithAccountId[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TournamentWithAccountId.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TournamentWithAccountId[]>(<any>null);
    }

    getTournamentsForUser(userId?: number | undefined): Observable<UserTournamentsResponse> {
        let url_ = this.baseUrl + "/api/Tournament/GetTournamentsForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTournamentsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTournamentsForUser(<any>response_);
                } catch (e) {
                    return <Observable<UserTournamentsResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<UserTournamentsResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTournamentsForUser(response: HttpResponseBase): Observable<UserTournamentsResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserTournamentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UserTournamentsResponse>(<any>null);
    }

    getTournamentLeaderboard(tournamentId?: number | undefined): Observable<LeaderBoardResponse> {
        let url_ = this.baseUrl + "/api/Tournament/GetTournamentLeaderboard?";
        if (tournamentId === null)
            throw new Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTournamentLeaderboard(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTournamentLeaderboard(<any>response_);
                } catch (e) {
                    return <Observable<LeaderBoardResponse>><any>_observableThrow(e);
                }
            } else
                return <Observable<LeaderBoardResponse>><any>_observableThrow(response_);
        }));
    }

    protected processGetTournamentLeaderboard(response: HttpResponseBase): Observable<LeaderBoardResponse> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LeaderBoardResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<LeaderBoardResponse>(<any>null);
    }

    deleteTournamentUserByIds(userId?: number | undefined, tournamentId?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Tournament/deleteTournamentUserByIds?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (tournamentId === null)
            throw new Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteTournamentUserByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteTournamentUserByIds(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processDeleteTournamentUserByIds(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    wasFirstLoginUserByIds(userId?: number | undefined, tournamentId?: number | undefined, wasLogin?: number | undefined): Observable<number> {
        let url_ = this.baseUrl + "/api/Tournament/wasFirstLoginUserByIds?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (tournamentId === null)
            throw new Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&"; 
        if (wasLogin === null)
            throw new Error("The parameter 'wasLogin' cannot be null.");
        else if (wasLogin !== undefined)
            url_ += "wasLogin=" + encodeURIComponent("" + wasLogin) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWasFirstLoginUserByIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWasFirstLoginUserByIds(<any>response_);
                } catch (e) {
                    return <Observable<number>><any>_observableThrow(e);
                }
            } else
                return <Observable<number>><any>_observableThrow(response_);
        }));
    }

    protected processWasFirstLoginUserByIds(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = resultData200 !== undefined ? resultData200 : <any>null;
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<number>(<any>null);
    }

    getlogisState(userId?: number | undefined, tournamentId?: number | undefined): Observable<TournamentUserAndAccount[]> {
        let url_ = this.baseUrl + "/api/Tournament/GetlogisState?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        if (tournamentId === null)
            throw new Error("The parameter 'tournamentId' cannot be null.");
        else if (tournamentId !== undefined)
            url_ += "tournamentId=" + encodeURIComponent("" + tournamentId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetlogisState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetlogisState(<any>response_);
                } catch (e) {
                    return <Observable<TournamentUserAndAccount[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TournamentUserAndAccount[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetlogisState(response: HttpResponseBase): Observable<TournamentUserAndAccount[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TournamentUserAndAccount.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TournamentUserAndAccount[]>(<any>null);
    }

    getAllTournamentsForUser(userId?: number | undefined): Observable<TournamentUserAndAccount[]> {
        let url_ = this.baseUrl + "/api/Tournament/GetAllTournamentsForUser?";
        if (userId === null)
            throw new Error("The parameter 'userId' cannot be null.");
        else if (userId !== undefined)
            url_ += "userId=" + encodeURIComponent("" + userId) + "&"; 
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllTournamentsForUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllTournamentsForUser(<any>response_);
                } catch (e) {
                    return <Observable<TournamentUserAndAccount[]>><any>_observableThrow(e);
                }
            } else
                return <Observable<TournamentUserAndAccount[]>><any>_observableThrow(response_);
        }));
    }

    protected processGetAllTournamentsForUser(response: HttpResponseBase): Observable<TournamentUserAndAccount[]> {
        const status = response.status;
        const responseBlob = 
            response instanceof HttpResponse ? response.body : 
            (<any>response).error instanceof Blob ? (<any>response).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }};
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(TournamentUserAndAccount.fromJS(item));
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<TournamentUserAndAccount[]>(<any>null);
    }
}

export class AccountOrderDataSumResponse implements IAccountOrderDataSumResponse {
    accountBalance?: AccountBalance[] | null;
    accountPips?: AccountPips[] | null;
    sumOfPips!: number;

    constructor(data?: IAccountOrderDataSumResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["accountBalance"])) {
                this.accountBalance = [] as any;
                for (let item of data["accountBalance"])
                    this.accountBalance!.push(AccountBalance.fromJS(item));
            }
            if (Array.isArray(data["accountPips"])) {
                this.accountPips = [] as any;
                for (let item of data["accountPips"])
                    this.accountPips!.push(AccountPips.fromJS(item));
            }
            this.sumOfPips = data["sumOfPips"] !== undefined ? data["sumOfPips"] : <any>null;
        }
    }

    static fromJS(data: any): AccountOrderDataSumResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountOrderDataSumResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountBalance)) {
            data["accountBalance"] = [];
            for (let item of this.accountBalance)
                data["accountBalance"].push(item.toJSON());
        }
        if (Array.isArray(this.accountPips)) {
            data["accountPips"] = [];
            for (let item of this.accountPips)
                data["accountPips"].push(item.toJSON());
        }
        data["sumOfPips"] = this.sumOfPips !== undefined ? this.sumOfPips : <any>null;
        return data; 
    }

    clone(): AccountOrderDataSumResponse {
        const json = this.toJSON();
        let result = new AccountOrderDataSumResponse();
        result.init(json);
        return result;
    }
}

export interface IAccountOrderDataSumResponse {
    accountBalance?: AccountBalance[] | null;
    accountPips?: AccountPips[] | null;
    sumOfPips: number;
}

export class AccountBalance implements IAccountBalance {
    pnLInTimeRange!: number;
    initialBalance!: number;
    endBalance!: number;

    constructor(data?: IAccountBalance) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.pnLInTimeRange = data["pnLInTimeRange"] !== undefined ? data["pnLInTimeRange"] : <any>null;
            this.initialBalance = data["initialBalance"] !== undefined ? data["initialBalance"] : <any>null;
            this.endBalance = data["endBalance"] !== undefined ? data["endBalance"] : <any>null;
        }
    }

    static fromJS(data: any): AccountBalance {
        data = typeof data === 'object' ? data : {};
        let result = new AccountBalance();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pnLInTimeRange"] = this.pnLInTimeRange !== undefined ? this.pnLInTimeRange : <any>null;
        data["initialBalance"] = this.initialBalance !== undefined ? this.initialBalance : <any>null;
        data["endBalance"] = this.endBalance !== undefined ? this.endBalance : <any>null;
        return data; 
    }

    clone(): AccountBalance {
        const json = this.toJSON();
        let result = new AccountBalance();
        result.init(json);
        return result;
    }
}

export interface IAccountBalance {
    pnLInTimeRange: number;
    initialBalance: number;
    endBalance: number;
}

export class AccountPips implements IAccountPips {
    buySell?: string | null;
    pips!: number;

    constructor(data?: IAccountPips) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.buySell = data["buySell"] !== undefined ? data["buySell"] : <any>null;
            this.pips = data["pips"] !== undefined ? data["pips"] : <any>null;
        }
    }

    static fromJS(data: any): AccountPips {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPips();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["buySell"] = this.buySell !== undefined ? this.buySell : <any>null;
        data["pips"] = this.pips !== undefined ? this.pips : <any>null;
        return data; 
    }

    clone(): AccountPips {
        const json = this.toJSON();
        let result = new AccountPips();
        result.init(json);
        return result;
    }
}

export interface IAccountPips {
    buySell?: string | null;
    pips: number;
}

export class Account implements IAccount {
    id!: number;
    userId?: number | null;
    accountName?: string | null;
    balance?: number | null;
    pnL!: number;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;

    constructor(data?: IAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.accountName = data["accountName"] !== undefined ? data["accountName"] : <any>null;
            this.balance = data["balance"] !== undefined ? data["balance"] : <any>null;
            this.pnL = data["pnL"] !== undefined ? data["pnL"] : <any>null;
            if (Array.isArray(data["tournamentUserAndAccount"])) {
                this.tournamentUserAndAccount = [] as any;
                for (let item of data["tournamentUserAndAccount"])
                    this.tournamentUserAndAccount!.push(TournamentUserAndAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Account {
        data = typeof data === 'object' ? data : {};
        let result = new Account();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["balance"] = this.balance !== undefined ? this.balance : <any>null;
        data["pnL"] = this.pnL !== undefined ? this.pnL : <any>null;
        if (Array.isArray(this.tournamentUserAndAccount)) {
            data["tournamentUserAndAccount"] = [];
            for (let item of this.tournamentUserAndAccount)
                data["tournamentUserAndAccount"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Account {
        const json = this.toJSON();
        let result = new Account();
        result.init(json);
        return result;
    }
}

export interface IAccount {
    id: number;
    userId?: number | null;
    accountName?: string | null;
    balance?: number | null;
    pnL: number;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;
}

export class TournamentUserAndAccount implements ITournamentUserAndAccount {
    id!: number;
    tournamentId!: number;
    userId!: number;
    accountId?: number | null;
    wasLogin!: number;
    syncedAsWinner!: boolean;
    account?: Account | null;
    tournament?: Tournament | null;
    user?: User | null;

    constructor(data?: ITournamentUserAndAccount) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.tournamentId = data["tournamentId"] !== undefined ? data["tournamentId"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.accountId = data["accountId"] !== undefined ? data["accountId"] : <any>null;
            this.wasLogin = data["wasLogin"] !== undefined ? data["wasLogin"] : <any>null;
            this.syncedAsWinner = data["syncedAsWinner"] !== undefined ? data["syncedAsWinner"] : <any>null;
            this.account = data["account"] ? Account.fromJS(data["account"]) : <any>null;
            this.tournament = data["tournament"] ? Tournament.fromJS(data["tournament"]) : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): TournamentUserAndAccount {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentUserAndAccount();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tournamentId"] = this.tournamentId !== undefined ? this.tournamentId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["wasLogin"] = this.wasLogin !== undefined ? this.wasLogin : <any>null;
        data["syncedAsWinner"] = this.syncedAsWinner !== undefined ? this.syncedAsWinner : <any>null;
        data["account"] = this.account ? this.account.toJSON() : <any>null;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): TournamentUserAndAccount {
        const json = this.toJSON();
        let result = new TournamentUserAndAccount();
        result.init(json);
        return result;
    }
}

export interface ITournamentUserAndAccount {
    id: number;
    tournamentId: number;
    userId: number;
    accountId?: number | null;
    wasLogin: number;
    syncedAsWinner: boolean;
    account?: Account | null;
    tournament?: Tournament | null;
    user?: User | null;
}

export class Tournament implements ITournament {
    id!: number;
    name?: string | null;
    challengeTypeId?: string | null;
    symbolListId?: number | null;
    infusionsoftTagUser?: string | null;
    infusionsoftTagUserId?: number | null;
    infusionsoftTagChallenge?: string | null;
    infusionsoftTagChallengeId?: number | null;
    startAdvertisingDateUtc!: moment.Moment;
    endAdvertisingDateUtc!: moment.Moment;
    hoursToRepeat!: number;
    startDateUtc!: moment.Moment;
    endDateUtc!: moment.Moment;
    startingBalance!: number;
    accountName?: string | null;
    description?: string | null;
    largeImage?: string | null;
    agreementUrl?: string | null;
    smallImage?: string | null;
    viewDetails?: string | null;
    inProgressImage?: string | null;
    rulesUrl?: string | null;
    firstLoginImage?: string | null;
    headerImage?: string | null;
    shortName?: string | null;
    overlayHtml?: string | null;
    largeImageFileName?: string | null;
    agreementUrlFileName?: string | null;
    smallImageFileName?: string | null;
    viewDetailsFileName?: string | null;
    inProgressImageFileName?: string | null;
    rulesUrlFileName?: string | null;
    firstLoginImageFileName?: string | null;
    headerImageFileName?: string | null;
    overlayHtmlfileName?: string | null;
    largeImageFileNameOrg?: string | null;
    agreementUrlFileNameOrg?: string | null;
    smallImageFileNameOrg?: string | null;
    viewDetailsFileNameOrg?: string | null;
    inProgressImageFileNameOrg?: string | null;
    rulesUrlFileNameOrg?: string | null;
    firstLoginImageFileNameOrg?: string | null;
    headerImageFileNameOrg?: string | null;
    overlayHtmlfileNameOrg?: string | null;
    countries?: string | null;
    challengeType?: ChallengeType | null;
    symbolList?: SymbolList | null;
    tournamentAssets?: TournamentAssets[] | null;
    tournamentAwards?: TournamentAwards[] | null;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;

    constructor(data?: ITournament) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.challengeTypeId = data["challengeTypeId"] !== undefined ? data["challengeTypeId"] : <any>null;
            this.symbolListId = data["symbolListId"] !== undefined ? data["symbolListId"] : <any>null;
            this.infusionsoftTagUser = data["infusionsoftTagUser"] !== undefined ? data["infusionsoftTagUser"] : <any>null;
            this.infusionsoftTagUserId = data["infusionsoftTagUserId"] !== undefined ? data["infusionsoftTagUserId"] : <any>null;
            this.infusionsoftTagChallenge = data["infusionsoftTagChallenge"] !== undefined ? data["infusionsoftTagChallenge"] : <any>null;
            this.infusionsoftTagChallengeId = data["infusionsoftTagChallengeId"] !== undefined ? data["infusionsoftTagChallengeId"] : <any>null;
            this.startAdvertisingDateUtc = data["startAdvertisingDateUtc"] ? moment(data["startAdvertisingDateUtc"].toString()) : <any>null;
            this.endAdvertisingDateUtc = data["endAdvertisingDateUtc"] ? moment(data["endAdvertisingDateUtc"].toString()) : <any>null;
            this.hoursToRepeat = data["hoursToRepeat"] !== undefined ? data["hoursToRepeat"] : <any>null;
            this.startDateUtc = data["startDateUtc"] ? moment(data["startDateUtc"].toString()) : <any>null;
            this.endDateUtc = data["endDateUtc"] ? moment(data["endDateUtc"].toString()) : <any>null;
            this.startingBalance = data["startingBalance"] !== undefined ? data["startingBalance"] : <any>null;
            this.accountName = data["accountName"] !== undefined ? data["accountName"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.largeImage = data["largeImage"] !== undefined ? data["largeImage"] : <any>null;
            this.agreementUrl = data["agreementUrl"] !== undefined ? data["agreementUrl"] : <any>null;
            this.smallImage = data["smallImage"] !== undefined ? data["smallImage"] : <any>null;
            this.viewDetails = data["viewDetails"] !== undefined ? data["viewDetails"] : <any>null;
            this.inProgressImage = data["inProgressImage"] !== undefined ? data["inProgressImage"] : <any>null;
            this.rulesUrl = data["rulesUrl"] !== undefined ? data["rulesUrl"] : <any>null;
            this.firstLoginImage = data["firstLoginImage"] !== undefined ? data["firstLoginImage"] : <any>null;
            this.headerImage = data["headerImage"] !== undefined ? data["headerImage"] : <any>null;
            this.shortName = data["shortName"] !== undefined ? data["shortName"] : <any>null;
            this.overlayHtml = data["overlayHtml"] !== undefined ? data["overlayHtml"] : <any>null;
            this.largeImageFileName = data["largeImageFileName"] !== undefined ? data["largeImageFileName"] : <any>null;
            this.agreementUrlFileName = data["agreementUrlFileName"] !== undefined ? data["agreementUrlFileName"] : <any>null;
            this.smallImageFileName = data["smallImageFileName"] !== undefined ? data["smallImageFileName"] : <any>null;
            this.viewDetailsFileName = data["viewDetailsFileName"] !== undefined ? data["viewDetailsFileName"] : <any>null;
            this.inProgressImageFileName = data["inProgressImageFileName"] !== undefined ? data["inProgressImageFileName"] : <any>null;
            this.rulesUrlFileName = data["rulesUrlFileName"] !== undefined ? data["rulesUrlFileName"] : <any>null;
            this.firstLoginImageFileName = data["firstLoginImageFileName"] !== undefined ? data["firstLoginImageFileName"] : <any>null;
            this.headerImageFileName = data["headerImageFileName"] !== undefined ? data["headerImageFileName"] : <any>null;
            this.overlayHtmlfileName = data["overlayHtmlfileName"] !== undefined ? data["overlayHtmlfileName"] : <any>null;
            this.largeImageFileNameOrg = data["largeImageFileNameOrg"] !== undefined ? data["largeImageFileNameOrg"] : <any>null;
            this.agreementUrlFileNameOrg = data["agreementUrlFileNameOrg"] !== undefined ? data["agreementUrlFileNameOrg"] : <any>null;
            this.smallImageFileNameOrg = data["smallImageFileNameOrg"] !== undefined ? data["smallImageFileNameOrg"] : <any>null;
            this.viewDetailsFileNameOrg = data["viewDetailsFileNameOrg"] !== undefined ? data["viewDetailsFileNameOrg"] : <any>null;
            this.inProgressImageFileNameOrg = data["inProgressImageFileNameOrg"] !== undefined ? data["inProgressImageFileNameOrg"] : <any>null;
            this.rulesUrlFileNameOrg = data["rulesUrlFileNameOrg"] !== undefined ? data["rulesUrlFileNameOrg"] : <any>null;
            this.firstLoginImageFileNameOrg = data["firstLoginImageFileNameOrg"] !== undefined ? data["firstLoginImageFileNameOrg"] : <any>null;
            this.headerImageFileNameOrg = data["headerImageFileNameOrg"] !== undefined ? data["headerImageFileNameOrg"] : <any>null;
            this.overlayHtmlfileNameOrg = data["overlayHtmlfileNameOrg"] !== undefined ? data["overlayHtmlfileNameOrg"] : <any>null;
            this.countries = data["countries"] !== undefined ? data["countries"] : <any>null;
            this.challengeType = data["challengeType"] ? ChallengeType.fromJS(data["challengeType"]) : <any>null;
            this.symbolList = data["symbolList"] ? SymbolList.fromJS(data["symbolList"]) : <any>null;
            if (Array.isArray(data["tournamentAssets"])) {
                this.tournamentAssets = [] as any;
                for (let item of data["tournamentAssets"])
                    this.tournamentAssets!.push(TournamentAssets.fromJS(item));
            }
            if (Array.isArray(data["tournamentAwards"])) {
                this.tournamentAwards = [] as any;
                for (let item of data["tournamentAwards"])
                    this.tournamentAwards!.push(TournamentAwards.fromJS(item));
            }
            if (Array.isArray(data["tournamentUserAndAccount"])) {
                this.tournamentUserAndAccount = [] as any;
                for (let item of data["tournamentUserAndAccount"])
                    this.tournamentUserAndAccount!.push(TournamentUserAndAccount.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Tournament {
        data = typeof data === 'object' ? data : {};
        let result = new Tournament();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["challengeTypeId"] = this.challengeTypeId !== undefined ? this.challengeTypeId : <any>null;
        data["symbolListId"] = this.symbolListId !== undefined ? this.symbolListId : <any>null;
        data["infusionsoftTagUser"] = this.infusionsoftTagUser !== undefined ? this.infusionsoftTagUser : <any>null;
        data["infusionsoftTagUserId"] = this.infusionsoftTagUserId !== undefined ? this.infusionsoftTagUserId : <any>null;
        data["infusionsoftTagChallenge"] = this.infusionsoftTagChallenge !== undefined ? this.infusionsoftTagChallenge : <any>null;
        data["infusionsoftTagChallengeId"] = this.infusionsoftTagChallengeId !== undefined ? this.infusionsoftTagChallengeId : <any>null;
        data["startAdvertisingDateUtc"] = this.startAdvertisingDateUtc ? this.startAdvertisingDateUtc.toISOString() : <any>null;
        data["endAdvertisingDateUtc"] = this.endAdvertisingDateUtc ? this.endAdvertisingDateUtc.toISOString() : <any>null;
        data["hoursToRepeat"] = this.hoursToRepeat !== undefined ? this.hoursToRepeat : <any>null;
        data["startDateUtc"] = this.startDateUtc ? this.startDateUtc.toISOString() : <any>null;
        data["endDateUtc"] = this.endDateUtc ? this.endDateUtc.toISOString() : <any>null;
        data["startingBalance"] = this.startingBalance !== undefined ? this.startingBalance : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["largeImage"] = this.largeImage !== undefined ? this.largeImage : <any>null;
        data["agreementUrl"] = this.agreementUrl !== undefined ? this.agreementUrl : <any>null;
        data["smallImage"] = this.smallImage !== undefined ? this.smallImage : <any>null;
        data["viewDetails"] = this.viewDetails !== undefined ? this.viewDetails : <any>null;
        data["inProgressImage"] = this.inProgressImage !== undefined ? this.inProgressImage : <any>null;
        data["rulesUrl"] = this.rulesUrl !== undefined ? this.rulesUrl : <any>null;
        data["firstLoginImage"] = this.firstLoginImage !== undefined ? this.firstLoginImage : <any>null;
        data["headerImage"] = this.headerImage !== undefined ? this.headerImage : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["overlayHtml"] = this.overlayHtml !== undefined ? this.overlayHtml : <any>null;
        data["largeImageFileName"] = this.largeImageFileName !== undefined ? this.largeImageFileName : <any>null;
        data["agreementUrlFileName"] = this.agreementUrlFileName !== undefined ? this.agreementUrlFileName : <any>null;
        data["smallImageFileName"] = this.smallImageFileName !== undefined ? this.smallImageFileName : <any>null;
        data["viewDetailsFileName"] = this.viewDetailsFileName !== undefined ? this.viewDetailsFileName : <any>null;
        data["inProgressImageFileName"] = this.inProgressImageFileName !== undefined ? this.inProgressImageFileName : <any>null;
        data["rulesUrlFileName"] = this.rulesUrlFileName !== undefined ? this.rulesUrlFileName : <any>null;
        data["firstLoginImageFileName"] = this.firstLoginImageFileName !== undefined ? this.firstLoginImageFileName : <any>null;
        data["headerImageFileName"] = this.headerImageFileName !== undefined ? this.headerImageFileName : <any>null;
        data["overlayHtmlfileName"] = this.overlayHtmlfileName !== undefined ? this.overlayHtmlfileName : <any>null;
        data["largeImageFileNameOrg"] = this.largeImageFileNameOrg !== undefined ? this.largeImageFileNameOrg : <any>null;
        data["agreementUrlFileNameOrg"] = this.agreementUrlFileNameOrg !== undefined ? this.agreementUrlFileNameOrg : <any>null;
        data["smallImageFileNameOrg"] = this.smallImageFileNameOrg !== undefined ? this.smallImageFileNameOrg : <any>null;
        data["viewDetailsFileNameOrg"] = this.viewDetailsFileNameOrg !== undefined ? this.viewDetailsFileNameOrg : <any>null;
        data["inProgressImageFileNameOrg"] = this.inProgressImageFileNameOrg !== undefined ? this.inProgressImageFileNameOrg : <any>null;
        data["rulesUrlFileNameOrg"] = this.rulesUrlFileNameOrg !== undefined ? this.rulesUrlFileNameOrg : <any>null;
        data["firstLoginImageFileNameOrg"] = this.firstLoginImageFileNameOrg !== undefined ? this.firstLoginImageFileNameOrg : <any>null;
        data["headerImageFileNameOrg"] = this.headerImageFileNameOrg !== undefined ? this.headerImageFileNameOrg : <any>null;
        data["overlayHtmlfileNameOrg"] = this.overlayHtmlfileNameOrg !== undefined ? this.overlayHtmlfileNameOrg : <any>null;
        data["countries"] = this.countries !== undefined ? this.countries : <any>null;
        data["challengeType"] = this.challengeType ? this.challengeType.toJSON() : <any>null;
        data["symbolList"] = this.symbolList ? this.symbolList.toJSON() : <any>null;
        if (Array.isArray(this.tournamentAssets)) {
            data["tournamentAssets"] = [];
            for (let item of this.tournamentAssets)
                data["tournamentAssets"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentAwards)) {
            data["tournamentAwards"] = [];
            for (let item of this.tournamentAwards)
                data["tournamentAwards"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentUserAndAccount)) {
            data["tournamentUserAndAccount"] = [];
            for (let item of this.tournamentUserAndAccount)
                data["tournamentUserAndAccount"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Tournament {
        const json = this.toJSON();
        let result = new Tournament();
        result.init(json);
        return result;
    }
}

export interface ITournament {
    id: number;
    name?: string | null;
    challengeTypeId?: string | null;
    symbolListId?: number | null;
    infusionsoftTagUser?: string | null;
    infusionsoftTagUserId?: number | null;
    infusionsoftTagChallenge?: string | null;
    infusionsoftTagChallengeId?: number | null;
    startAdvertisingDateUtc: moment.Moment;
    endAdvertisingDateUtc: moment.Moment;
    hoursToRepeat: number;
    startDateUtc: moment.Moment;
    endDateUtc: moment.Moment;
    startingBalance: number;
    accountName?: string | null;
    description?: string | null;
    largeImage?: string | null;
    agreementUrl?: string | null;
    smallImage?: string | null;
    viewDetails?: string | null;
    inProgressImage?: string | null;
    rulesUrl?: string | null;
    firstLoginImage?: string | null;
    headerImage?: string | null;
    shortName?: string | null;
    overlayHtml?: string | null;
    largeImageFileName?: string | null;
    agreementUrlFileName?: string | null;
    smallImageFileName?: string | null;
    viewDetailsFileName?: string | null;
    inProgressImageFileName?: string | null;
    rulesUrlFileName?: string | null;
    firstLoginImageFileName?: string | null;
    headerImageFileName?: string | null;
    overlayHtmlfileName?: string | null;
    largeImageFileNameOrg?: string | null;
    agreementUrlFileNameOrg?: string | null;
    smallImageFileNameOrg?: string | null;
    viewDetailsFileNameOrg?: string | null;
    inProgressImageFileNameOrg?: string | null;
    rulesUrlFileNameOrg?: string | null;
    firstLoginImageFileNameOrg?: string | null;
    headerImageFileNameOrg?: string | null;
    overlayHtmlfileNameOrg?: string | null;
    countries?: string | null;
    challengeType?: ChallengeType | null;
    symbolList?: SymbolList | null;
    tournamentAssets?: TournamentAssets[] | null;
    tournamentAwards?: TournamentAwards[] | null;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;
}

export class ChallengeType implements IChallengeType {
    challengeTypeId?: string | null;
    tournament?: Tournament[] | null;

    constructor(data?: IChallengeType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.challengeTypeId = data["challengeTypeId"] !== undefined ? data["challengeTypeId"] : <any>null;
            if (Array.isArray(data["tournament"])) {
                this.tournament = [] as any;
                for (let item of data["tournament"])
                    this.tournament!.push(Tournament.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ChallengeType {
        data = typeof data === 'object' ? data : {};
        let result = new ChallengeType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["challengeTypeId"] = this.challengeTypeId !== undefined ? this.challengeTypeId : <any>null;
        if (Array.isArray(this.tournament)) {
            data["tournament"] = [];
            for (let item of this.tournament)
                data["tournament"].push(item.toJSON());
        }
        return data; 
    }

    clone(): ChallengeType {
        const json = this.toJSON();
        let result = new ChallengeType();
        result.init(json);
        return result;
    }
}

export interface IChallengeType {
    challengeTypeId?: string | null;
    tournament?: Tournament[] | null;
}

export class SymbolList implements ISymbolList {
    symbolListId!: number;
    symbolListName?: string | null;
    symbolListSymbol?: SymbolListSymbol[] | null;
    tournament?: Tournament[] | null;

    constructor(data?: ISymbolList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.symbolListId = data["symbolListId"] !== undefined ? data["symbolListId"] : <any>null;
            this.symbolListName = data["symbolListName"] !== undefined ? data["symbolListName"] : <any>null;
            if (Array.isArray(data["symbolListSymbol"])) {
                this.symbolListSymbol = [] as any;
                for (let item of data["symbolListSymbol"])
                    this.symbolListSymbol!.push(SymbolListSymbol.fromJS(item));
            }
            if (Array.isArray(data["tournament"])) {
                this.tournament = [] as any;
                for (let item of data["tournament"])
                    this.tournament!.push(Tournament.fromJS(item));
            }
        }
    }

    static fromJS(data: any): SymbolList {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["symbolListId"] = this.symbolListId !== undefined ? this.symbolListId : <any>null;
        data["symbolListName"] = this.symbolListName !== undefined ? this.symbolListName : <any>null;
        if (Array.isArray(this.symbolListSymbol)) {
            data["symbolListSymbol"] = [];
            for (let item of this.symbolListSymbol)
                data["symbolListSymbol"].push(item.toJSON());
        }
        if (Array.isArray(this.tournament)) {
            data["tournament"] = [];
            for (let item of this.tournament)
                data["tournament"].push(item.toJSON());
        }
        return data; 
    }

    clone(): SymbolList {
        const json = this.toJSON();
        let result = new SymbolList();
        result.init(json);
        return result;
    }
}

export interface ISymbolList {
    symbolListId: number;
    symbolListName?: string | null;
    symbolListSymbol?: SymbolListSymbol[] | null;
    tournament?: Tournament[] | null;
}

export class SymbolListSymbol implements ISymbolListSymbol {
    id!: number;
    symbolListId!: number;
    symbol?: string | null;
    symbolList?: SymbolList | null;

    constructor(data?: ISymbolListSymbol) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.symbolListId = data["symbolListId"] !== undefined ? data["symbolListId"] : <any>null;
            this.symbol = data["symbol"] !== undefined ? data["symbol"] : <any>null;
            this.symbolList = data["symbolList"] ? SymbolList.fromJS(data["symbolList"]) : <any>null;
        }
    }

    static fromJS(data: any): SymbolListSymbol {
        data = typeof data === 'object' ? data : {};
        let result = new SymbolListSymbol();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["symbolListId"] = this.symbolListId !== undefined ? this.symbolListId : <any>null;
        data["symbol"] = this.symbol !== undefined ? this.symbol : <any>null;
        data["symbolList"] = this.symbolList ? this.symbolList.toJSON() : <any>null;
        return data; 
    }

    clone(): SymbolListSymbol {
        const json = this.toJSON();
        let result = new SymbolListSymbol();
        result.init(json);
        return result;
    }
}

export interface ISymbolListSymbol {
    id: number;
    symbolListId: number;
    symbol?: string | null;
    symbolList?: SymbolList | null;
}

export class TournamentAssets implements ITournamentAssets {
    id!: number;
    tournamentId!: number;
    assetId!: number;
    asset?: Assets | null;
    tournament?: Tournament | null;

    constructor(data?: ITournamentAssets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.tournamentId = data["tournamentId"] !== undefined ? data["tournamentId"] : <any>null;
            this.assetId = data["assetId"] !== undefined ? data["assetId"] : <any>null;
            this.asset = data["asset"] ? Assets.fromJS(data["asset"]) : <any>null;
            this.tournament = data["tournament"] ? Tournament.fromJS(data["tournament"]) : <any>null;
        }
    }

    static fromJS(data: any): TournamentAssets {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentAssets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tournamentId"] = this.tournamentId !== undefined ? this.tournamentId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>null;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : <any>null;
        return data; 
    }

    clone(): TournamentAssets {
        const json = this.toJSON();
        let result = new TournamentAssets();
        result.init(json);
        return result;
    }
}

export interface ITournamentAssets {
    id: number;
    tournamentId: number;
    assetId: number;
    asset?: Assets | null;
    tournament?: Tournament | null;
}

export class Assets implements IAssets {
    id!: number;
    name?: string | null;
    tournamentAssets?: TournamentAssets[] | null;

    constructor(data?: IAssets) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            if (Array.isArray(data["tournamentAssets"])) {
                this.tournamentAssets = [] as any;
                for (let item of data["tournamentAssets"])
                    this.tournamentAssets!.push(TournamentAssets.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Assets {
        data = typeof data === 'object' ? data : {};
        let result = new Assets();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.tournamentAssets)) {
            data["tournamentAssets"] = [];
            for (let item of this.tournamentAssets)
                data["tournamentAssets"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Assets {
        const json = this.toJSON();
        let result = new Assets();
        result.init(json);
        return result;
    }
}

export interface IAssets {
    id: number;
    name?: string | null;
    tournamentAssets?: TournamentAssets[] | null;
}

export class TournamentAwards implements ITournamentAwards {
    id!: number;
    tournamentId!: number;
    prizePos!: number;
    prize?: string | null;
    tournament?: Tournament | null;

    constructor(data?: ITournamentAwards) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.tournamentId = data["tournamentId"] !== undefined ? data["tournamentId"] : <any>null;
            this.prizePos = data["prizePos"] !== undefined ? data["prizePos"] : <any>null;
            this.prize = data["prize"] !== undefined ? data["prize"] : <any>null;
            this.tournament = data["tournament"] ? Tournament.fromJS(data["tournament"]) : <any>null;
        }
    }

    static fromJS(data: any): TournamentAwards {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentAwards();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["tournamentId"] = this.tournamentId !== undefined ? this.tournamentId : <any>null;
        data["prizePos"] = this.prizePos !== undefined ? this.prizePos : <any>null;
        data["prize"] = this.prize !== undefined ? this.prize : <any>null;
        data["tournament"] = this.tournament ? this.tournament.toJSON() : <any>null;
        return data; 
    }

    clone(): TournamentAwards {
        const json = this.toJSON();
        let result = new TournamentAwards();
        result.init(json);
        return result;
    }
}

export interface ITournamentAwards {
    id: number;
    tournamentId: number;
    prizePos: number;
    prize?: string | null;
    tournament?: Tournament | null;
}

export class User implements IUser {
    id!: number;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    lastUpdated!: moment.Moment;
    password?: string | null;
    contactId?: number | null;
    tagIds?: string | null;
    phone?: string | null;
    country?: string | null;
    userTypeId!: number;
    isEnabled?: boolean | null;
    company?: string | null;
    street?: string | null;
    city?: string | null;
    region?: string | null;
    postCode?: string | null;
    firstFax?: string | null;
    lastLoginDate!: moment.Moment;
    createdAt?: moment.Moment | null;
    isActive!: number;
    lastSelectedProvider?: string | null;
    userType?: UserType | null;
    alertState?: AlertState[] | null;
    asorder?: Asorder[] | null;
    providerActions?: ProviderActions[] | null;
    rating?: Rating[] | null;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;
    userGroups?: UserGroups[] | null;
    userMessage?: UserMessage[] | null;

    constructor(data?: IUser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
            this.lastUpdated = data["lastUpdated"] ? moment(data["lastUpdated"].toString()) : <any>null;
            this.password = data["password"] !== undefined ? data["password"] : <any>null;
            this.contactId = data["contactId"] !== undefined ? data["contactId"] : <any>null;
            this.tagIds = data["tagIds"] !== undefined ? data["tagIds"] : <any>null;
            this.phone = data["phone"] !== undefined ? data["phone"] : <any>null;
            this.country = data["country"] !== undefined ? data["country"] : <any>null;
            this.userTypeId = data["userTypeId"] !== undefined ? data["userTypeId"] : <any>null;
            this.isEnabled = data["isEnabled"] !== undefined ? data["isEnabled"] : <any>null;
            this.company = data["company"] !== undefined ? data["company"] : <any>null;
            this.street = data["street"] !== undefined ? data["street"] : <any>null;
            this.city = data["city"] !== undefined ? data["city"] : <any>null;
            this.region = data["region"] !== undefined ? data["region"] : <any>null;
            this.postCode = data["postCode"] !== undefined ? data["postCode"] : <any>null;
            this.firstFax = data["firstFax"] !== undefined ? data["firstFax"] : <any>null;
            this.lastLoginDate = data["lastLoginDate"] ? moment(data["lastLoginDate"].toString()) : <any>null;
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            this.lastSelectedProvider = data["lastSelectedProvider"] !== undefined ? data["lastSelectedProvider"] : <any>null;
            this.userType = data["userType"] ? UserType.fromJS(data["userType"]) : <any>null;
            if (Array.isArray(data["alertState"])) {
                this.alertState = [] as any;
                for (let item of data["alertState"])
                    this.alertState!.push(AlertState.fromJS(item));
            }
            if (Array.isArray(data["asorder"])) {
                this.asorder = [] as any;
                for (let item of data["asorder"])
                    this.asorder!.push(Asorder.fromJS(item));
            }
            if (Array.isArray(data["providerActions"])) {
                this.providerActions = [] as any;
                for (let item of data["providerActions"])
                    this.providerActions!.push(ProviderActions.fromJS(item));
            }
            if (Array.isArray(data["rating"])) {
                this.rating = [] as any;
                for (let item of data["rating"])
                    this.rating!.push(Rating.fromJS(item));
            }
            if (Array.isArray(data["tournamentUserAndAccount"])) {
                this.tournamentUserAndAccount = [] as any;
                for (let item of data["tournamentUserAndAccount"])
                    this.tournamentUserAndAccount!.push(TournamentUserAndAccount.fromJS(item));
            }
            if (Array.isArray(data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of data["userGroups"])
                    this.userGroups!.push(UserGroups.fromJS(item));
            }
            if (Array.isArray(data["userMessage"])) {
                this.userMessage = [] as any;
                for (let item of data["userMessage"])
                    this.userMessage!.push(UserMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): User {
        data = typeof data === 'object' ? data : {};
        let result = new User();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["contactId"] = this.contactId !== undefined ? this.contactId : <any>null;
        data["tagIds"] = this.tagIds !== undefined ? this.tagIds : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["userTypeId"] = this.userTypeId !== undefined ? this.userTypeId : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["region"] = this.region !== undefined ? this.region : <any>null;
        data["postCode"] = this.postCode !== undefined ? this.postCode : <any>null;
        data["firstFax"] = this.firstFax !== undefined ? this.firstFax : <any>null;
        data["lastLoginDate"] = this.lastLoginDate ? this.lastLoginDate.toISOString() : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["lastSelectedProvider"] = this.lastSelectedProvider !== undefined ? this.lastSelectedProvider : <any>null;
        data["userType"] = this.userType ? this.userType.toJSON() : <any>null;
        if (Array.isArray(this.alertState)) {
            data["alertState"] = [];
            for (let item of this.alertState)
                data["alertState"].push(item.toJSON());
        }
        if (Array.isArray(this.asorder)) {
            data["asorder"] = [];
            for (let item of this.asorder)
                data["asorder"].push(item.toJSON());
        }
        if (Array.isArray(this.providerActions)) {
            data["providerActions"] = [];
            for (let item of this.providerActions)
                data["providerActions"].push(item.toJSON());
        }
        if (Array.isArray(this.rating)) {
            data["rating"] = [];
            for (let item of this.rating)
                data["rating"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentUserAndAccount)) {
            data["tournamentUserAndAccount"] = [];
            for (let item of this.tournamentUserAndAccount)
                data["tournamentUserAndAccount"].push(item.toJSON());
        }
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        if (Array.isArray(this.userMessage)) {
            data["userMessage"] = [];
            for (let item of this.userMessage)
                data["userMessage"].push(item.toJSON());
        }
        return data; 
    }

    clone(): User {
        const json = this.toJSON();
        let result = new User();
        result.init(json);
        return result;
    }
}

export interface IUser {
    id: number;
    email?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    lastUpdated: moment.Moment;
    password?: string | null;
    contactId?: number | null;
    tagIds?: string | null;
    phone?: string | null;
    country?: string | null;
    userTypeId: number;
    isEnabled?: boolean | null;
    company?: string | null;
    street?: string | null;
    city?: string | null;
    region?: string | null;
    postCode?: string | null;
    firstFax?: string | null;
    lastLoginDate: moment.Moment;
    createdAt?: moment.Moment | null;
    isActive: number;
    lastSelectedProvider?: string | null;
    userType?: UserType | null;
    alertState?: AlertState[] | null;
    asorder?: Asorder[] | null;
    providerActions?: ProviderActions[] | null;
    rating?: Rating[] | null;
    tournamentUserAndAccount?: TournamentUserAndAccount[] | null;
    userGroups?: UserGroups[] | null;
    userMessage?: UserMessage[] | null;
}

export class UserType implements IUserType {
    userTypeId!: number;
    userType1?: string | null;
    user?: User[] | null;

    constructor(data?: IUserType) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userTypeId = data["userTypeId"] !== undefined ? data["userTypeId"] : <any>null;
            this.userType1 = data["userType1"] !== undefined ? data["userType1"] : <any>null;
            if (Array.isArray(data["user"])) {
                this.user = [] as any;
                for (let item of data["user"])
                    this.user!.push(User.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserType {
        data = typeof data === 'object' ? data : {};
        let result = new UserType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userTypeId"] = this.userTypeId !== undefined ? this.userTypeId : <any>null;
        data["userType1"] = this.userType1 !== undefined ? this.userType1 : <any>null;
        if (Array.isArray(this.user)) {
            data["user"] = [];
            for (let item of this.user)
                data["user"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserType {
        const json = this.toJSON();
        let result = new UserType();
        result.init(json);
        return result;
    }
}

export interface IUserType {
    userTypeId: number;
    userType1?: string | null;
    user?: User[] | null;
}

export class AlertState implements IAlertState {
    id!: number;
    userId!: number;
    alertId!: number;
    state!: number;
    alert?: Alert | null;
    user?: User | null;

    constructor(data?: IAlertState) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.alertId = data["alertId"] !== undefined ? data["alertId"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.alert = data["alert"] ? Alert.fromJS(data["alert"]) : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): AlertState {
        data = typeof data === 'object' ? data : {};
        let result = new AlertState();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["alertId"] = this.alertId !== undefined ? this.alertId : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["alert"] = this.alert ? this.alert.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): AlertState {
        const json = this.toJSON();
        let result = new AlertState();
        result.init(json);
        return result;
    }
}

export interface IAlertState {
    id: number;
    userId: number;
    alertId: number;
    state: number;
    alert?: Alert | null;
    user?: User | null;
}

export class Alert implements IAlert {
    date!: moment.Moment;
    id!: number;
    header?: string | null;
    action?: string | null;
    currencyPair?: string | null;
    tradeDirection?: string | null;
    entryPrice?: string | null;
    orderType?: string | null;
    stopLoss?: string | null;
    portfolio?: string | null;
    strategy?: string | null;
    profitLoss?: string | null;
    adjustStop?: string | null;
    adjustProfit?: string | null;
    initialRate?: string | null;
    closingRate?: string | null;
    takeProfits?: string | null;
    messageId?: string | null;
    alertState?: AlertState[] | null;

    constructor(data?: IAlert) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.date = data["date"] ? moment(data["date"].toString()) : <any>null;
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.header = data["header"] !== undefined ? data["header"] : <any>null;
            this.action = data["action"] !== undefined ? data["action"] : <any>null;
            this.currencyPair = data["currencyPair"] !== undefined ? data["currencyPair"] : <any>null;
            this.tradeDirection = data["tradeDirection"] !== undefined ? data["tradeDirection"] : <any>null;
            this.entryPrice = data["entryPrice"] !== undefined ? data["entryPrice"] : <any>null;
            this.orderType = data["orderType"] !== undefined ? data["orderType"] : <any>null;
            this.stopLoss = data["stopLoss"] !== undefined ? data["stopLoss"] : <any>null;
            this.portfolio = data["portfolio"] !== undefined ? data["portfolio"] : <any>null;
            this.strategy = data["strategy"] !== undefined ? data["strategy"] : <any>null;
            this.profitLoss = data["profitLoss"] !== undefined ? data["profitLoss"] : <any>null;
            this.adjustStop = data["adjustStop"] !== undefined ? data["adjustStop"] : <any>null;
            this.adjustProfit = data["adjustProfit"] !== undefined ? data["adjustProfit"] : <any>null;
            this.initialRate = data["initialRate"] !== undefined ? data["initialRate"] : <any>null;
            this.closingRate = data["closingRate"] !== undefined ? data["closingRate"] : <any>null;
            this.takeProfits = data["takeProfits"] !== undefined ? data["takeProfits"] : <any>null;
            this.messageId = data["messageId"] !== undefined ? data["messageId"] : <any>null;
            if (Array.isArray(data["alertState"])) {
                this.alertState = [] as any;
                for (let item of data["alertState"])
                    this.alertState!.push(AlertState.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Alert {
        data = typeof data === 'object' ? data : {};
        let result = new Alert();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["header"] = this.header !== undefined ? this.header : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["currencyPair"] = this.currencyPair !== undefined ? this.currencyPair : <any>null;
        data["tradeDirection"] = this.tradeDirection !== undefined ? this.tradeDirection : <any>null;
        data["entryPrice"] = this.entryPrice !== undefined ? this.entryPrice : <any>null;
        data["orderType"] = this.orderType !== undefined ? this.orderType : <any>null;
        data["stopLoss"] = this.stopLoss !== undefined ? this.stopLoss : <any>null;
        data["portfolio"] = this.portfolio !== undefined ? this.portfolio : <any>null;
        data["strategy"] = this.strategy !== undefined ? this.strategy : <any>null;
        data["profitLoss"] = this.profitLoss !== undefined ? this.profitLoss : <any>null;
        data["adjustStop"] = this.adjustStop !== undefined ? this.adjustStop : <any>null;
        data["adjustProfit"] = this.adjustProfit !== undefined ? this.adjustProfit : <any>null;
        data["initialRate"] = this.initialRate !== undefined ? this.initialRate : <any>null;
        data["closingRate"] = this.closingRate !== undefined ? this.closingRate : <any>null;
        data["takeProfits"] = this.takeProfits !== undefined ? this.takeProfits : <any>null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : <any>null;
        if (Array.isArray(this.alertState)) {
            data["alertState"] = [];
            for (let item of this.alertState)
                data["alertState"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Alert {
        const json = this.toJSON();
        let result = new Alert();
        result.init(json);
        return result;
    }
}

export interface IAlert {
    date: moment.Moment;
    id: number;
    header?: string | null;
    action?: string | null;
    currencyPair?: string | null;
    tradeDirection?: string | null;
    entryPrice?: string | null;
    orderType?: string | null;
    stopLoss?: string | null;
    portfolio?: string | null;
    strategy?: string | null;
    profitLoss?: string | null;
    adjustStop?: string | null;
    adjustProfit?: string | null;
    initialRate?: string | null;
    closingRate?: string | null;
    takeProfits?: string | null;
    messageId?: string | null;
    alertState?: AlertState[] | null;
}

export class Asorder implements IAsorder {
    asorderId!: number;
    userId!: number;
    date!: moment.Moment;
    firstName?: string | null;
    lastName?: string | null;
    company?: string | null;
    country?: string | null;
    city?: string | null;
    name?: string | null;
    phone?: string | null;
    street?: string | null;
    postalCode?: string | null;
    email?: string | null;
    orderToken?: string | null;
    state?: number | null;
    isTrial?: boolean | null;
    checkoutData?: string | null;
    checkoutUrl?: string | null;
    shopifyOrderId?: string | null;
    shopifyOrderDate?: moment.Moment | null;
    shopifyOrderNumber?: number | null;
    user?: User | null;
    asorderDetail?: AsorderDetail[] | null;

    constructor(data?: IAsorder) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.asorderId = data["asorderId"] !== undefined ? data["asorderId"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.date = data["date"] ? moment(data["date"].toString()) : <any>null;
            this.firstName = data["firstName"] !== undefined ? data["firstName"] : <any>null;
            this.lastName = data["lastName"] !== undefined ? data["lastName"] : <any>null;
            this.company = data["company"] !== undefined ? data["company"] : <any>null;
            this.country = data["country"] !== undefined ? data["country"] : <any>null;
            this.city = data["city"] !== undefined ? data["city"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.phone = data["phone"] !== undefined ? data["phone"] : <any>null;
            this.street = data["street"] !== undefined ? data["street"] : <any>null;
            this.postalCode = data["postalCode"] !== undefined ? data["postalCode"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.orderToken = data["orderToken"] !== undefined ? data["orderToken"] : <any>null;
            this.state = data["state"] !== undefined ? data["state"] : <any>null;
            this.isTrial = data["isTrial"] !== undefined ? data["isTrial"] : <any>null;
            this.checkoutData = data["checkoutData"] !== undefined ? data["checkoutData"] : <any>null;
            this.checkoutUrl = data["checkoutUrl"] !== undefined ? data["checkoutUrl"] : <any>null;
            this.shopifyOrderId = data["shopifyOrderId"] !== undefined ? data["shopifyOrderId"] : <any>null;
            this.shopifyOrderDate = data["shopifyOrderDate"] ? moment(data["shopifyOrderDate"].toString()) : <any>null;
            this.shopifyOrderNumber = data["shopifyOrderNumber"] !== undefined ? data["shopifyOrderNumber"] : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
            if (Array.isArray(data["asorderDetail"])) {
                this.asorderDetail = [] as any;
                for (let item of data["asorderDetail"])
                    this.asorderDetail!.push(AsorderDetail.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Asorder {
        data = typeof data === 'object' ? data : {};
        let result = new Asorder();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asorderId"] = this.asorderId !== undefined ? this.asorderId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["date"] = this.date ? this.date.toISOString() : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["company"] = this.company !== undefined ? this.company : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["street"] = this.street !== undefined ? this.street : <any>null;
        data["postalCode"] = this.postalCode !== undefined ? this.postalCode : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["orderToken"] = this.orderToken !== undefined ? this.orderToken : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["isTrial"] = this.isTrial !== undefined ? this.isTrial : <any>null;
        data["checkoutData"] = this.checkoutData !== undefined ? this.checkoutData : <any>null;
        data["checkoutUrl"] = this.checkoutUrl !== undefined ? this.checkoutUrl : <any>null;
        data["shopifyOrderId"] = this.shopifyOrderId !== undefined ? this.shopifyOrderId : <any>null;
        data["shopifyOrderDate"] = this.shopifyOrderDate ? this.shopifyOrderDate.toISOString() : <any>null;
        data["shopifyOrderNumber"] = this.shopifyOrderNumber !== undefined ? this.shopifyOrderNumber : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        if (Array.isArray(this.asorderDetail)) {
            data["asorderDetail"] = [];
            for (let item of this.asorderDetail)
                data["asorderDetail"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Asorder {
        const json = this.toJSON();
        let result = new Asorder();
        result.init(json);
        return result;
    }
}

export interface IAsorder {
    asorderId: number;
    userId: number;
    date: moment.Moment;
    firstName?: string | null;
    lastName?: string | null;
    company?: string | null;
    country?: string | null;
    city?: string | null;
    name?: string | null;
    phone?: string | null;
    street?: string | null;
    postalCode?: string | null;
    email?: string | null;
    orderToken?: string | null;
    state?: number | null;
    isTrial?: boolean | null;
    checkoutData?: string | null;
    checkoutUrl?: string | null;
    shopifyOrderId?: string | null;
    shopifyOrderDate?: moment.Moment | null;
    shopifyOrderNumber?: number | null;
    user?: User | null;
    asorderDetail?: AsorderDetail[] | null;
}

export class AsorderDetail implements IAsorderDetail {
    asorderDetailId!: number;
    asorderId!: number;
    productId!: number;
    isTrial!: boolean;
    startTime?: moment.Moment | null;
    endTime?: moment.Moment | null;
    notificationTime?: moment.Moment | null;
    notificationSent!: boolean;
    price!: number;
    enableSubscribction!: boolean;
    subscribcionProcessed!: boolean;
    asorder?: Asorder | null;
    product?: Product | null;
    rating?: Rating[] | null;

    constructor(data?: IAsorderDetail) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.asorderDetailId = data["asorderDetailId"] !== undefined ? data["asorderDetailId"] : <any>null;
            this.asorderId = data["asorderId"] !== undefined ? data["asorderId"] : <any>null;
            this.productId = data["productId"] !== undefined ? data["productId"] : <any>null;
            this.isTrial = data["isTrial"] !== undefined ? data["isTrial"] : <any>null;
            this.startTime = data["startTime"] ? moment(data["startTime"].toString()) : <any>null;
            this.endTime = data["endTime"] ? moment(data["endTime"].toString()) : <any>null;
            this.notificationTime = data["notificationTime"] ? moment(data["notificationTime"].toString()) : <any>null;
            this.notificationSent = data["notificationSent"] !== undefined ? data["notificationSent"] : <any>null;
            this.price = data["price"] !== undefined ? data["price"] : <any>null;
            this.enableSubscribction = data["enableSubscribction"] !== undefined ? data["enableSubscribction"] : <any>null;
            this.subscribcionProcessed = data["subscribcionProcessed"] !== undefined ? data["subscribcionProcessed"] : <any>null;
            this.asorder = data["asorder"] ? Asorder.fromJS(data["asorder"]) : <any>null;
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>null;
            if (Array.isArray(data["rating"])) {
                this.rating = [] as any;
                for (let item of data["rating"])
                    this.rating!.push(Rating.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AsorderDetail {
        data = typeof data === 'object' ? data : {};
        let result = new AsorderDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["asorderDetailId"] = this.asorderDetailId !== undefined ? this.asorderDetailId : <any>null;
        data["asorderId"] = this.asorderId !== undefined ? this.asorderId : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["isTrial"] = this.isTrial !== undefined ? this.isTrial : <any>null;
        data["startTime"] = this.startTime ? this.startTime.toISOString() : <any>null;
        data["endTime"] = this.endTime ? this.endTime.toISOString() : <any>null;
        data["notificationTime"] = this.notificationTime ? this.notificationTime.toISOString() : <any>null;
        data["notificationSent"] = this.notificationSent !== undefined ? this.notificationSent : <any>null;
        data["price"] = this.price !== undefined ? this.price : <any>null;
        data["enableSubscribction"] = this.enableSubscribction !== undefined ? this.enableSubscribction : <any>null;
        data["subscribcionProcessed"] = this.subscribcionProcessed !== undefined ? this.subscribcionProcessed : <any>null;
        data["asorder"] = this.asorder ? this.asorder.toJSON() : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        if (Array.isArray(this.rating)) {
            data["rating"] = [];
            for (let item of this.rating)
                data["rating"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AsorderDetail {
        const json = this.toJSON();
        let result = new AsorderDetail();
        result.init(json);
        return result;
    }
}

export interface IAsorderDetail {
    asorderDetailId: number;
    asorderId: number;
    productId: number;
    isTrial: boolean;
    startTime?: moment.Moment | null;
    endTime?: moment.Moment | null;
    notificationTime?: moment.Moment | null;
    notificationSent: boolean;
    price: number;
    enableSubscribction: boolean;
    subscribcionProcessed: boolean;
    asorder?: Asorder | null;
    product?: Product | null;
    rating?: Rating[] | null;
}

export class Product implements IProduct {
    id!: number;
    name?: string | null;
    description?: string | null;
    isEnabled?: boolean | null;
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
    sku?: string | null;
    smallImage?: string | null;
    smallImageFileName?: string | null;
    smallImageFileNameOrg?: string | null;
    regularImage?: string | null;
    regularImageFileNameOrg?: string | null;
    regularImageFileName?: string | null;
    notificationTime?: number | null;
    trialTime?: number | null;
    rateVirtual?: number | null;
    rateCount?: number | null;
    rateFixed?: boolean | null;
    asorderDetail?: AsorderDetail[] | null;
    productCategory?: ProductCategory[] | null;
    productInternalTag?: ProductInternalTag[] | null;
    productProperties?: ProductProperties[] | null;
    productToProductProduct?: ProductToProduct[] | null;
    productToProductSubProduct?: ProductToProduct[] | null;
    rating?: Rating[] | null;

    constructor(data?: IProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.isEnabled = data["isEnabled"] !== undefined ? data["isEnabled"] : <any>null;
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>null;
            this.endDate = data["endDate"] ? moment(data["endDate"].toString()) : <any>null;
            this.sku = data["sku"] !== undefined ? data["sku"] : <any>null;
            this.smallImage = data["smallImage"] !== undefined ? data["smallImage"] : <any>null;
            this.smallImageFileName = data["smallImageFileName"] !== undefined ? data["smallImageFileName"] : <any>null;
            this.smallImageFileNameOrg = data["smallImageFileNameOrg"] !== undefined ? data["smallImageFileNameOrg"] : <any>null;
            this.regularImage = data["regularImage"] !== undefined ? data["regularImage"] : <any>null;
            this.regularImageFileNameOrg = data["regularImageFileNameOrg"] !== undefined ? data["regularImageFileNameOrg"] : <any>null;
            this.regularImageFileName = data["regularImageFileName"] !== undefined ? data["regularImageFileName"] : <any>null;
            this.notificationTime = data["notificationTime"] !== undefined ? data["notificationTime"] : <any>null;
            this.trialTime = data["trialTime"] !== undefined ? data["trialTime"] : <any>null;
            this.rateVirtual = data["rateVirtual"] !== undefined ? data["rateVirtual"] : <any>null;
            this.rateCount = data["rateCount"] !== undefined ? data["rateCount"] : <any>null;
            this.rateFixed = data["rateFixed"] !== undefined ? data["rateFixed"] : <any>null;
            if (Array.isArray(data["asorderDetail"])) {
                this.asorderDetail = [] as any;
                for (let item of data["asorderDetail"])
                    this.asorderDetail!.push(AsorderDetail.fromJS(item));
            }
            if (Array.isArray(data["productCategory"])) {
                this.productCategory = [] as any;
                for (let item of data["productCategory"])
                    this.productCategory!.push(ProductCategory.fromJS(item));
            }
            if (Array.isArray(data["productInternalTag"])) {
                this.productInternalTag = [] as any;
                for (let item of data["productInternalTag"])
                    this.productInternalTag!.push(ProductInternalTag.fromJS(item));
            }
            if (Array.isArray(data["productProperties"])) {
                this.productProperties = [] as any;
                for (let item of data["productProperties"])
                    this.productProperties!.push(ProductProperties.fromJS(item));
            }
            if (Array.isArray(data["productToProductProduct"])) {
                this.productToProductProduct = [] as any;
                for (let item of data["productToProductProduct"])
                    this.productToProductProduct!.push(ProductToProduct.fromJS(item));
            }
            if (Array.isArray(data["productToProductSubProduct"])) {
                this.productToProductSubProduct = [] as any;
                for (let item of data["productToProductSubProduct"])
                    this.productToProductSubProduct!.push(ProductToProduct.fromJS(item));
            }
            if (Array.isArray(data["rating"])) {
                this.rating = [] as any;
                for (let item of data["rating"])
                    this.rating!.push(Rating.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Product {
        data = typeof data === 'object' ? data : {};
        let result = new Product();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["isEnabled"] = this.isEnabled !== undefined ? this.isEnabled : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : <any>null;
        data["sku"] = this.sku !== undefined ? this.sku : <any>null;
        data["smallImage"] = this.smallImage !== undefined ? this.smallImage : <any>null;
        data["smallImageFileName"] = this.smallImageFileName !== undefined ? this.smallImageFileName : <any>null;
        data["smallImageFileNameOrg"] = this.smallImageFileNameOrg !== undefined ? this.smallImageFileNameOrg : <any>null;
        data["regularImage"] = this.regularImage !== undefined ? this.regularImage : <any>null;
        data["regularImageFileNameOrg"] = this.regularImageFileNameOrg !== undefined ? this.regularImageFileNameOrg : <any>null;
        data["regularImageFileName"] = this.regularImageFileName !== undefined ? this.regularImageFileName : <any>null;
        data["notificationTime"] = this.notificationTime !== undefined ? this.notificationTime : <any>null;
        data["trialTime"] = this.trialTime !== undefined ? this.trialTime : <any>null;
        data["rateVirtual"] = this.rateVirtual !== undefined ? this.rateVirtual : <any>null;
        data["rateCount"] = this.rateCount !== undefined ? this.rateCount : <any>null;
        data["rateFixed"] = this.rateFixed !== undefined ? this.rateFixed : <any>null;
        if (Array.isArray(this.asorderDetail)) {
            data["asorderDetail"] = [];
            for (let item of this.asorderDetail)
                data["asorderDetail"].push(item.toJSON());
        }
        if (Array.isArray(this.productCategory)) {
            data["productCategory"] = [];
            for (let item of this.productCategory)
                data["productCategory"].push(item.toJSON());
        }
        if (Array.isArray(this.productInternalTag)) {
            data["productInternalTag"] = [];
            for (let item of this.productInternalTag)
                data["productInternalTag"].push(item.toJSON());
        }
        if (Array.isArray(this.productProperties)) {
            data["productProperties"] = [];
            for (let item of this.productProperties)
                data["productProperties"].push(item.toJSON());
        }
        if (Array.isArray(this.productToProductProduct)) {
            data["productToProductProduct"] = [];
            for (let item of this.productToProductProduct)
                data["productToProductProduct"].push(item.toJSON());
        }
        if (Array.isArray(this.productToProductSubProduct)) {
            data["productToProductSubProduct"] = [];
            for (let item of this.productToProductSubProduct)
                data["productToProductSubProduct"].push(item.toJSON());
        }
        if (Array.isArray(this.rating)) {
            data["rating"] = [];
            for (let item of this.rating)
                data["rating"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Product {
        const json = this.toJSON();
        let result = new Product();
        result.init(json);
        return result;
    }
}

export interface IProduct {
    id: number;
    name?: string | null;
    description?: string | null;
    isEnabled?: boolean | null;
    startDate?: moment.Moment | null;
    endDate?: moment.Moment | null;
    sku?: string | null;
    smallImage?: string | null;
    smallImageFileName?: string | null;
    smallImageFileNameOrg?: string | null;
    regularImage?: string | null;
    regularImageFileNameOrg?: string | null;
    regularImageFileName?: string | null;
    notificationTime?: number | null;
    trialTime?: number | null;
    rateVirtual?: number | null;
    rateCount?: number | null;
    rateFixed?: boolean | null;
    asorderDetail?: AsorderDetail[] | null;
    productCategory?: ProductCategory[] | null;
    productInternalTag?: ProductInternalTag[] | null;
    productProperties?: ProductProperties[] | null;
    productToProductProduct?: ProductToProduct[] | null;
    productToProductSubProduct?: ProductToProduct[] | null;
    rating?: Rating[] | null;
}

export class ProductCategory implements IProductCategory {
    id!: number;
    productId!: number;
    categoryId!: number;
    category?: Category | null;
    product?: Product | null;

    constructor(data?: IProductCategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.productId = data["productId"] !== undefined ? data["productId"] : <any>null;
            this.categoryId = data["categoryId"] !== undefined ? data["categoryId"] : <any>null;
            this.category = data["category"] ? Category.fromJS(data["category"]) : <any>null;
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): ProductCategory {
        data = typeof data === 'object' ? data : {};
        let result = new ProductCategory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["category"] = this.category ? this.category.toJSON() : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data; 
    }

    clone(): ProductCategory {
        const json = this.toJSON();
        let result = new ProductCategory();
        result.init(json);
        return result;
    }
}

export interface IProductCategory {
    id: number;
    productId: number;
    categoryId: number;
    category?: Category | null;
    product?: Product | null;
}

export class Category implements ICategory {
    id!: number;
    name?: string | null;
    productCategory?: ProductCategory[] | null;

    constructor(data?: ICategory) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            if (Array.isArray(data["productCategory"])) {
                this.productCategory = [] as any;
                for (let item of data["productCategory"])
                    this.productCategory!.push(ProductCategory.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Category {
        data = typeof data === 'object' ? data : {};
        let result = new Category();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        if (Array.isArray(this.productCategory)) {
            data["productCategory"] = [];
            for (let item of this.productCategory)
                data["productCategory"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Category {
        const json = this.toJSON();
        let result = new Category();
        result.init(json);
        return result;
    }
}

export interface ICategory {
    id: number;
    name?: string | null;
    productCategory?: ProductCategory[] | null;
}

export class ProductInternalTag implements IProductInternalTag {
    id!: number;
    productId!: number;
    internalTagId!: number;
    internalTag?: InternalTag | null;
    product?: Product | null;

    constructor(data?: IProductInternalTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.productId = data["productId"] !== undefined ? data["productId"] : <any>null;
            this.internalTagId = data["internalTagId"] !== undefined ? data["internalTagId"] : <any>null;
            this.internalTag = data["internalTag"] ? InternalTag.fromJS(data["internalTag"]) : <any>null;
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): ProductInternalTag {
        data = typeof data === 'object' ? data : {};
        let result = new ProductInternalTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["internalTagId"] = this.internalTagId !== undefined ? this.internalTagId : <any>null;
        data["internalTag"] = this.internalTag ? this.internalTag.toJSON() : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data; 
    }

    clone(): ProductInternalTag {
        const json = this.toJSON();
        let result = new ProductInternalTag();
        result.init(json);
        return result;
    }
}

export interface IProductInternalTag {
    id: number;
    productId: number;
    internalTagId: number;
    internalTag?: InternalTag | null;
    product?: Product | null;
}

export class InternalTag implements IInternalTag {
    id!: number;
    name?: string | null;
    isActive!: number;
    productInternalTag?: ProductInternalTag[] | null;

    constructor(data?: IInternalTag) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.isActive = data["isActive"] !== undefined ? data["isActive"] : <any>null;
            if (Array.isArray(data["productInternalTag"])) {
                this.productInternalTag = [] as any;
                for (let item of data["productInternalTag"])
                    this.productInternalTag!.push(ProductInternalTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): InternalTag {
        data = typeof data === 'object' ? data : {};
        let result = new InternalTag();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.productInternalTag)) {
            data["productInternalTag"] = [];
            for (let item of this.productInternalTag)
                data["productInternalTag"].push(item.toJSON());
        }
        return data; 
    }

    clone(): InternalTag {
        const json = this.toJSON();
        let result = new InternalTag();
        result.init(json);
        return result;
    }
}

export interface IInternalTag {
    id: number;
    name?: string | null;
    isActive: number;
    productInternalTag?: ProductInternalTag[] | null;
}

export class ProductProperties implements IProductProperties {
    id!: number;
    regularPrice!: number;
    type!: number;
    pricePromotionRegular!: number;
    pricePromotionInstitutional!: number;
    subscriptionRanges!: number;
    startDate!: moment.Moment;
    stopDate?: moment.Moment | null;
    image?: string | null;
    name?: string | null;
    description?: string | null;
    productId!: number;
    zadowo?: string | null;
    product?: Product | null;

    constructor(data?: IProductProperties) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.regularPrice = data["regularPrice"] !== undefined ? data["regularPrice"] : <any>null;
            this.type = data["type"] !== undefined ? data["type"] : <any>null;
            this.pricePromotionRegular = data["pricePromotionRegular"] !== undefined ? data["pricePromotionRegular"] : <any>null;
            this.pricePromotionInstitutional = data["pricePromotionInstitutional"] !== undefined ? data["pricePromotionInstitutional"] : <any>null;
            this.subscriptionRanges = data["subscriptionRanges"] !== undefined ? data["subscriptionRanges"] : <any>null;
            this.startDate = data["startDate"] ? moment(data["startDate"].toString()) : <any>null;
            this.stopDate = data["stopDate"] ? moment(data["stopDate"].toString()) : <any>null;
            this.image = data["image"] !== undefined ? data["image"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            this.productId = data["productId"] !== undefined ? data["productId"] : <any>null;
            this.zadowo = data["zadowo"] !== undefined ? data["zadowo"] : <any>null;
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>null;
        }
    }

    static fromJS(data: any): ProductProperties {
        data = typeof data === 'object' ? data : {};
        let result = new ProductProperties();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["regularPrice"] = this.regularPrice !== undefined ? this.regularPrice : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["pricePromotionRegular"] = this.pricePromotionRegular !== undefined ? this.pricePromotionRegular : <any>null;
        data["pricePromotionInstitutional"] = this.pricePromotionInstitutional !== undefined ? this.pricePromotionInstitutional : <any>null;
        data["subscriptionRanges"] = this.subscriptionRanges !== undefined ? this.subscriptionRanges : <any>null;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : <any>null;
        data["stopDate"] = this.stopDate ? this.stopDate.toISOString() : <any>null;
        data["image"] = this.image !== undefined ? this.image : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["zadowo"] = this.zadowo !== undefined ? this.zadowo : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        return data; 
    }

    clone(): ProductProperties {
        const json = this.toJSON();
        let result = new ProductProperties();
        result.init(json);
        return result;
    }
}

export interface IProductProperties {
    id: number;
    regularPrice: number;
    type: number;
    pricePromotionRegular: number;
    pricePromotionInstitutional: number;
    subscriptionRanges: number;
    startDate: moment.Moment;
    stopDate?: moment.Moment | null;
    image?: string | null;
    name?: string | null;
    description?: string | null;
    productId: number;
    zadowo?: string | null;
    product?: Product | null;
}

export class ProductToProduct implements IProductToProduct {
    id!: number;
    productId!: number;
    subProductId!: number;
    product?: Product | null;
    subProduct?: Product | null;

    constructor(data?: IProductToProduct) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.productId = data["productId"] !== undefined ? data["productId"] : <any>null;
            this.subProductId = data["subProductId"] !== undefined ? data["subProductId"] : <any>null;
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>null;
            this.subProduct = data["subProduct"] ? Product.fromJS(data["subProduct"]) : <any>null;
        }
    }

    static fromJS(data: any): ProductToProduct {
        data = typeof data === 'object' ? data : {};
        let result = new ProductToProduct();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["subProductId"] = this.subProductId !== undefined ? this.subProductId : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["subProduct"] = this.subProduct ? this.subProduct.toJSON() : <any>null;
        return data; 
    }

    clone(): ProductToProduct {
        const json = this.toJSON();
        let result = new ProductToProduct();
        result.init(json);
        return result;
    }
}

export interface IProductToProduct {
    id: number;
    productId: number;
    subProductId: number;
    product?: Product | null;
    subProduct?: Product | null;
}

export class Rating implements IRating {
    id!: number;
    userId!: number;
    productId!: number;
    orderDetailId!: number;
    rate!: number;
    createdAt!: moment.Moment;
    orderDetail?: AsorderDetail | null;
    product?: Product | null;
    user?: User | null;

    constructor(data?: IRating) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.productId = data["productId"] !== undefined ? data["productId"] : <any>null;
            this.orderDetailId = data["orderDetailId"] !== undefined ? data["orderDetailId"] : <any>null;
            this.rate = data["rate"] !== undefined ? data["rate"] : <any>null;
            this.createdAt = data["createdAt"] ? moment(data["createdAt"].toString()) : <any>null;
            this.orderDetail = data["orderDetail"] ? AsorderDetail.fromJS(data["orderDetail"]) : <any>null;
            this.product = data["product"] ? Product.fromJS(data["product"]) : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): Rating {
        data = typeof data === 'object' ? data : {};
        let result = new Rating();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["productId"] = this.productId !== undefined ? this.productId : <any>null;
        data["orderDetailId"] = this.orderDetailId !== undefined ? this.orderDetailId : <any>null;
        data["rate"] = this.rate !== undefined ? this.rate : <any>null;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>null;
        data["orderDetail"] = this.orderDetail ? this.orderDetail.toJSON() : <any>null;
        data["product"] = this.product ? this.product.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): Rating {
        const json = this.toJSON();
        let result = new Rating();
        result.init(json);
        return result;
    }
}

export interface IRating {
    id: number;
    userId: number;
    productId: number;
    orderDetailId: number;
    rate: number;
    createdAt: moment.Moment;
    orderDetail?: AsorderDetail | null;
    product?: Product | null;
    user?: User | null;
}

export class ProviderActions implements IProviderActions {
    id!: number;
    userId!: number;
    accountId?: string | null;
    provider?: string | null;
    entryType?: string | null;
    dateTime!: moment.Moment;
    data?: string | null;
    user?: User | null;

    constructor(data?: IProviderActions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.accountId = data["accountId"] !== undefined ? data["accountId"] : <any>null;
            this.provider = data["provider"] !== undefined ? data["provider"] : <any>null;
            this.entryType = data["entryType"] !== undefined ? data["entryType"] : <any>null;
            this.dateTime = data["dateTime"] ? moment(data["dateTime"].toString()) : <any>null;
            this.data = data["data"] !== undefined ? data["data"] : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): ProviderActions {
        data = typeof data === 'object' ? data : {};
        let result = new ProviderActions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["entryType"] = this.entryType !== undefined ? this.entryType : <any>null;
        data["dateTime"] = this.dateTime ? this.dateTime.toISOString() : <any>null;
        data["data"] = this.data !== undefined ? this.data : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): ProviderActions {
        const json = this.toJSON();
        let result = new ProviderActions();
        result.init(json);
        return result;
    }
}

export interface IProviderActions {
    id: number;
    userId: number;
    accountId?: string | null;
    provider?: string | null;
    entryType?: string | null;
    dateTime: moment.Moment;
    data?: string | null;
    user?: User | null;
}

export class UserGroups implements IUserGroups {
    id!: number;
    userId!: number;
    groupId!: number;
    group?: Groups | null;
    user?: User | null;

    constructor(data?: IUserGroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.groupId = data["groupId"] !== undefined ? data["groupId"] : <any>null;
            this.group = data["group"] ? Groups.fromJS(data["group"]) : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): UserGroups {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["groupId"] = this.groupId !== undefined ? this.groupId : <any>null;
        data["group"] = this.group ? this.group.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): UserGroups {
        const json = this.toJSON();
        let result = new UserGroups();
        result.init(json);
        return result;
    }
}

export interface IUserGroups {
    id: number;
    userId: number;
    groupId: number;
    group?: Groups | null;
    user?: User | null;
}

export class Groups implements IGroups {
    id!: number;
    name?: string | null;
    description?: string | null;
    groupMessage?: GroupMessage[] | null;
    userGroups?: UserGroups[] | null;

    constructor(data?: IGroups) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.name = data["name"] !== undefined ? data["name"] : <any>null;
            this.description = data["description"] !== undefined ? data["description"] : <any>null;
            if (Array.isArray(data["groupMessage"])) {
                this.groupMessage = [] as any;
                for (let item of data["groupMessage"])
                    this.groupMessage!.push(GroupMessage.fromJS(item));
            }
            if (Array.isArray(data["userGroups"])) {
                this.userGroups = [] as any;
                for (let item of data["userGroups"])
                    this.userGroups!.push(UserGroups.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Groups {
        data = typeof data === 'object' ? data : {};
        let result = new Groups();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        if (Array.isArray(this.groupMessage)) {
            data["groupMessage"] = [];
            for (let item of this.groupMessage)
                data["groupMessage"].push(item.toJSON());
        }
        if (Array.isArray(this.userGroups)) {
            data["userGroups"] = [];
            for (let item of this.userGroups)
                data["userGroups"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Groups {
        const json = this.toJSON();
        let result = new Groups();
        result.init(json);
        return result;
    }
}

export interface IGroups {
    id: number;
    name?: string | null;
    description?: string | null;
    groupMessage?: GroupMessage[] | null;
    userGroups?: UserGroups[] | null;
}

export class GroupMessage implements IGroupMessage {
    id!: number;
    messageId?: number | null;
    groupId?: number | null;
    group?: Groups | null;
    message?: Message | null;

    constructor(data?: IGroupMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.messageId = data["messageId"] !== undefined ? data["messageId"] : <any>null;
            this.groupId = data["groupId"] !== undefined ? data["groupId"] : <any>null;
            this.group = data["group"] ? Groups.fromJS(data["group"]) : <any>null;
            this.message = data["message"] ? Message.fromJS(data["message"]) : <any>null;
        }
    }

    static fromJS(data: any): GroupMessage {
        data = typeof data === 'object' ? data : {};
        let result = new GroupMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : <any>null;
        data["groupId"] = this.groupId !== undefined ? this.groupId : <any>null;
        data["group"] = this.group ? this.group.toJSON() : <any>null;
        data["message"] = this.message ? this.message.toJSON() : <any>null;
        return data; 
    }

    clone(): GroupMessage {
        const json = this.toJSON();
        let result = new GroupMessage();
        result.init(json);
        return result;
    }
}

export interface IGroupMessage {
    id: number;
    messageId?: number | null;
    groupId?: number | null;
    group?: Groups | null;
    message?: Message | null;
}

export class Message implements IMessage {
    id!: number;
    messageSubject?: string | null;
    messageContent?: string | null;
    sendToAll?: boolean | null;
    sendToGroup?: boolean | null;
    sendToUser?: boolean | null;
    sendByApp?: boolean | null;
    sendByMail?: boolean | null;
    timestamp!: moment.Moment;
    groupMessage?: GroupMessage[] | null;
    userMessage?: UserMessage[] | null;

    constructor(data?: IMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.messageSubject = data["messageSubject"] !== undefined ? data["messageSubject"] : <any>null;
            this.messageContent = data["messageContent"] !== undefined ? data["messageContent"] : <any>null;
            this.sendToAll = data["sendToAll"] !== undefined ? data["sendToAll"] : <any>null;
            this.sendToGroup = data["sendToGroup"] !== undefined ? data["sendToGroup"] : <any>null;
            this.sendToUser = data["sendToUser"] !== undefined ? data["sendToUser"] : <any>null;
            this.sendByApp = data["sendByApp"] !== undefined ? data["sendByApp"] : <any>null;
            this.sendByMail = data["sendByMail"] !== undefined ? data["sendByMail"] : <any>null;
            this.timestamp = data["timestamp"] ? moment(data["timestamp"].toString()) : <any>null;
            if (Array.isArray(data["groupMessage"])) {
                this.groupMessage = [] as any;
                for (let item of data["groupMessage"])
                    this.groupMessage!.push(GroupMessage.fromJS(item));
            }
            if (Array.isArray(data["userMessage"])) {
                this.userMessage = [] as any;
                for (let item of data["userMessage"])
                    this.userMessage!.push(UserMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): Message {
        data = typeof data === 'object' ? data : {};
        let result = new Message();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["messageSubject"] = this.messageSubject !== undefined ? this.messageSubject : <any>null;
        data["messageContent"] = this.messageContent !== undefined ? this.messageContent : <any>null;
        data["sendToAll"] = this.sendToAll !== undefined ? this.sendToAll : <any>null;
        data["sendToGroup"] = this.sendToGroup !== undefined ? this.sendToGroup : <any>null;
        data["sendToUser"] = this.sendToUser !== undefined ? this.sendToUser : <any>null;
        data["sendByApp"] = this.sendByApp !== undefined ? this.sendByApp : <any>null;
        data["sendByMail"] = this.sendByMail !== undefined ? this.sendByMail : <any>null;
        data["timestamp"] = this.timestamp ? this.timestamp.toISOString() : <any>null;
        if (Array.isArray(this.groupMessage)) {
            data["groupMessage"] = [];
            for (let item of this.groupMessage)
                data["groupMessage"].push(item.toJSON());
        }
        if (Array.isArray(this.userMessage)) {
            data["userMessage"] = [];
            for (let item of this.userMessage)
                data["userMessage"].push(item.toJSON());
        }
        return data; 
    }

    clone(): Message {
        const json = this.toJSON();
        let result = new Message();
        result.init(json);
        return result;
    }
}

export interface IMessage {
    id: number;
    messageSubject?: string | null;
    messageContent?: string | null;
    sendToAll?: boolean | null;
    sendToGroup?: boolean | null;
    sendToUser?: boolean | null;
    sendByApp?: boolean | null;
    sendByMail?: boolean | null;
    timestamp: moment.Moment;
    groupMessage?: GroupMessage[] | null;
    userMessage?: UserMessage[] | null;
}

export class UserMessage implements IUserMessage {
    id!: number;
    messageId?: number | null;
    userId?: number | null;
    readTimestamp?: moment.Moment | null;
    message?: Message | null;
    user?: User | null;

    constructor(data?: IUserMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.id = data["id"] !== undefined ? data["id"] : <any>null;
            this.messageId = data["messageId"] !== undefined ? data["messageId"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.readTimestamp = data["readTimestamp"] ? moment(data["readTimestamp"].toString()) : <any>null;
            this.message = data["message"] ? Message.fromJS(data["message"]) : <any>null;
            this.user = data["user"] ? User.fromJS(data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): UserMessage {
        data = typeof data === 'object' ? data : {};
        let result = new UserMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["messageId"] = this.messageId !== undefined ? this.messageId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["readTimestamp"] = this.readTimestamp ? this.readTimestamp.toISOString() : <any>null;
        data["message"] = this.message ? this.message.toJSON() : <any>null;
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data; 
    }

    clone(): UserMessage {
        const json = this.toJSON();
        let result = new UserMessage();
        result.init(json);
        return result;
    }
}

export interface IUserMessage {
    id: number;
    messageId?: number | null;
    userId?: number | null;
    readTimestamp?: moment.Moment | null;
    message?: Message | null;
    user?: User | null;
}

export class AppStoreInfoModel implements IAppStoreInfoModel {
    products?: Product[] | null;
    categories?: Category[] | null;
    tags?: InternalTag[] | null;

    constructor(data?: IAppStoreInfoModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["products"])) {
                this.products = [] as any;
                for (let item of data["products"])
                    this.products!.push(Product.fromJS(item));
            }
            if (Array.isArray(data["categories"])) {
                this.categories = [] as any;
                for (let item of data["categories"])
                    this.categories!.push(Category.fromJS(item));
            }
            if (Array.isArray(data["tags"])) {
                this.tags = [] as any;
                for (let item of data["tags"])
                    this.tags!.push(InternalTag.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AppStoreInfoModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppStoreInfoModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        if (Array.isArray(this.categories)) {
            data["categories"] = [];
            for (let item of this.categories)
                data["categories"].push(item.toJSON());
        }
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item.toJSON());
        }
        return data; 
    }

    clone(): AppStoreInfoModel {
        const json = this.toJSON();
        let result = new AppStoreInfoModel();
        result.init(json);
        return result;
    }
}

export interface IAppStoreInfoModel {
    products?: Product[] | null;
    categories?: Category[] | null;
    tags?: InternalTag[] | null;
}

export class GetUserActiveProductsRes implements IGetUserActiveProductsRes {
    products?: AsorderDetail[] | null;
    currentTime!: moment.Moment;

    constructor(data?: IGetUserActiveProductsRes) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["products"])) {
                this.products = [] as any;
                for (let item of data["products"])
                    this.products!.push(AsorderDetail.fromJS(item));
            }
            this.currentTime = data["currentTime"] ? moment(data["currentTime"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): GetUserActiveProductsRes {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserActiveProductsRes();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.products)) {
            data["products"] = [];
            for (let item of this.products)
                data["products"].push(item.toJSON());
        }
        data["currentTime"] = this.currentTime ? this.currentTime.toISOString() : <any>null;
        return data; 
    }

    clone(): GetUserActiveProductsRes {
        const json = this.toJSON();
        let result = new GetUserActiveProductsRes();
        result.init(json);
        return result;
    }
}

export interface IGetUserActiveProductsRes {
    products?: AsorderDetail[] | null;
    currentTime: moment.Moment;
}

export class StartTrialResponseModel implements IStartTrialResponseModel {
    orderDetail?: AsorderDetail[] | null;
    message?: string | null;
    error?: string | null;

    constructor(data?: IStartTrialResponseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["orderDetail"])) {
                this.orderDetail = [] as any;
                for (let item of data["orderDetail"])
                    this.orderDetail!.push(AsorderDetail.fromJS(item));
            }
            this.message = data["message"] !== undefined ? data["message"] : <any>null;
            this.error = data["error"] !== undefined ? data["error"] : <any>null;
        }
    }

    static fromJS(data: any): StartTrialResponseModel {
        data = typeof data === 'object' ? data : {};
        let result = new StartTrialResponseModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.orderDetail)) {
            data["orderDetail"] = [];
            for (let item of this.orderDetail)
                data["orderDetail"].push(item.toJSON());
        }
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data; 
    }

    clone(): StartTrialResponseModel {
        const json = this.toJSON();
        let result = new StartTrialResponseModel();
        result.init(json);
        return result;
    }
}

export interface IStartTrialResponseModel {
    orderDetail?: AsorderDetail[] | null;
    message?: string | null;
    error?: string | null;
}

export class OrderResult implements IOrderResult {
    order?: Asorder | null;
    error?: string | null;

    constructor(data?: IOrderResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.order = data["order"] ? Asorder.fromJS(data["order"]) : <any>null;
            this.error = data["error"] !== undefined ? data["error"] : <any>null;
        }
    }

    static fromJS(data: any): OrderResult {
        data = typeof data === 'object' ? data : {};
        let result = new OrderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["order"] = this.order ? this.order.toJSON() : <any>null;
        data["error"] = this.error !== undefined ? this.error : <any>null;
        return data; 
    }

    clone(): OrderResult {
        const json = this.toJSON();
        let result = new OrderResult();
        result.init(json);
        return result;
    }
}

export interface IOrderResult {
    order?: Asorder | null;
    error?: string | null;
}

export class CheckoutData implements ICheckoutData {
    sessionKey?: string | null;
    userId!: number;
    sku?: string | null;
    chekaoutId?: string | null;
    checkoutUrl?: string | null;
    checkoutData?: string | null;
    orderId?: number | null;

    constructor(data?: ICheckoutData) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.sessionKey = data["sessionKey"] !== undefined ? data["sessionKey"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.sku = data["sku"] !== undefined ? data["sku"] : <any>null;
            this.chekaoutId = data["chekaoutId"] !== undefined ? data["chekaoutId"] : <any>null;
            this.checkoutUrl = data["checkoutUrl"] !== undefined ? data["checkoutUrl"] : <any>null;
            this.checkoutData = data["checkoutData"] !== undefined ? data["checkoutData"] : <any>null;
            this.orderId = data["orderId"] !== undefined ? data["orderId"] : <any>null;
        }
    }

    static fromJS(data: any): CheckoutData {
        data = typeof data === 'object' ? data : {};
        let result = new CheckoutData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionKey"] = this.sessionKey !== undefined ? this.sessionKey : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["sku"] = this.sku !== undefined ? this.sku : <any>null;
        data["chekaoutId"] = this.chekaoutId !== undefined ? this.chekaoutId : <any>null;
        data["checkoutUrl"] = this.checkoutUrl !== undefined ? this.checkoutUrl : <any>null;
        data["checkoutData"] = this.checkoutData !== undefined ? this.checkoutData : <any>null;
        data["orderId"] = this.orderId !== undefined ? this.orderId : <any>null;
        return data; 
    }

    clone(): CheckoutData {
        const json = this.toJSON();
        let result = new CheckoutData();
        result.init(json);
        return result;
    }
}

export interface ICheckoutData {
    sessionKey?: string | null;
    userId: number;
    sku?: string | null;
    chekaoutId?: string | null;
    checkoutUrl?: string | null;
    checkoutData?: string | null;
    orderId?: number | null;
}

export class Adveristment implements IAdveristment {
    adveristmentId!: number;
    title?: string | null;
    bannerImageFile?: string | null;
    bannerImageFileOrg?: string | null;
    bannerImage?: string | null;
    dateStart!: moment.Moment;
    dateEnd?: moment.Moment | null;
    link?: string | null;

    constructor(data?: IAdveristment) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.adveristmentId = data["adveristmentId"] !== undefined ? data["adveristmentId"] : <any>null;
            this.title = data["title"] !== undefined ? data["title"] : <any>null;
            this.bannerImageFile = data["bannerImageFile"] !== undefined ? data["bannerImageFile"] : <any>null;
            this.bannerImageFileOrg = data["bannerImageFileOrg"] !== undefined ? data["bannerImageFileOrg"] : <any>null;
            this.bannerImage = data["bannerImage"] !== undefined ? data["bannerImage"] : <any>null;
            this.dateStart = data["dateStart"] ? moment(data["dateStart"].toString()) : <any>null;
            this.dateEnd = data["dateEnd"] ? moment(data["dateEnd"].toString()) : <any>null;
            this.link = data["link"] !== undefined ? data["link"] : <any>null;
        }
    }

    static fromJS(data: any): Adveristment {
        data = typeof data === 'object' ? data : {};
        let result = new Adveristment();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["adveristmentId"] = this.adveristmentId !== undefined ? this.adveristmentId : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["bannerImageFile"] = this.bannerImageFile !== undefined ? this.bannerImageFile : <any>null;
        data["bannerImageFileOrg"] = this.bannerImageFileOrg !== undefined ? this.bannerImageFileOrg : <any>null;
        data["bannerImage"] = this.bannerImage !== undefined ? this.bannerImage : <any>null;
        data["dateStart"] = this.dateStart ? this.dateStart.toISOString() : <any>null;
        data["dateEnd"] = this.dateEnd ? this.dateEnd.toISOString() : <any>null;
        data["link"] = this.link !== undefined ? this.link : <any>null;
        return data; 
    }

    clone(): Adveristment {
        const json = this.toJSON();
        let result = new Adveristment();
        result.init(json);
        return result;
    }
}

export interface IAdveristment {
    adveristmentId: number;
    title?: string | null;
    bannerImageFile?: string | null;
    bannerImageFileOrg?: string | null;
    bannerImage?: string | null;
    dateStart: moment.Moment;
    dateEnd?: moment.Moment | null;
    link?: string | null;
}

export class InfusionToken implements IInfusionToken {
    access_token?: string | null;
    refresh_token?: string | null;
    token_type?: string | null;
    scope?: string | null;
    expires_in!: number;
    token_recieved!: moment.Moment;

    constructor(data?: IInfusionToken) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.access_token = data["access_token"] !== undefined ? data["access_token"] : <any>null;
            this.refresh_token = data["refresh_token"] !== undefined ? data["refresh_token"] : <any>null;
            this.token_type = data["token_type"] !== undefined ? data["token_type"] : <any>null;
            this.scope = data["scope"] !== undefined ? data["scope"] : <any>null;
            this.expires_in = data["expires_in"] !== undefined ? data["expires_in"] : <any>null;
            this.token_recieved = data["token_recieved"] ? moment(data["token_recieved"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): InfusionToken {
        data = typeof data === 'object' ? data : {};
        let result = new InfusionToken();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["access_token"] = this.access_token !== undefined ? this.access_token : <any>null;
        data["refresh_token"] = this.refresh_token !== undefined ? this.refresh_token : <any>null;
        data["token_type"] = this.token_type !== undefined ? this.token_type : <any>null;
        data["scope"] = this.scope !== undefined ? this.scope : <any>null;
        data["expires_in"] = this.expires_in !== undefined ? this.expires_in : <any>null;
        data["token_recieved"] = this.token_recieved ? this.token_recieved.toISOString() : <any>null;
        return data; 
    }

    clone(): InfusionToken {
        const json = this.toJSON();
        let result = new InfusionToken();
        result.init(json);
        return result;
    }
}

export interface IInfusionToken {
    access_token?: string | null;
    refresh_token?: string | null;
    token_type?: string | null;
    scope?: string | null;
    expires_in: number;
    token_recieved: moment.Moment;
}

export class TradingProvider implements ITradingProvider {
    providerId?: string | null;
    clientName?: string | null;
    clientId?: string | null;
    clientSecret?: string | null;
    redirect?: string | null;

    constructor(data?: ITradingProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.providerId = data["providerId"] !== undefined ? data["providerId"] : <any>null;
            this.clientName = data["clientName"] !== undefined ? data["clientName"] : <any>null;
            this.clientId = data["clientId"] !== undefined ? data["clientId"] : <any>null;
            this.clientSecret = data["clientSecret"] !== undefined ? data["clientSecret"] : <any>null;
            this.redirect = data["redirect"] !== undefined ? data["redirect"] : <any>null;
        }
    }

    static fromJS(data: any): TradingProvider {
        data = typeof data === 'object' ? data : {};
        let result = new TradingProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["providerId"] = this.providerId !== undefined ? this.providerId : <any>null;
        data["clientName"] = this.clientName !== undefined ? this.clientName : <any>null;
        data["clientId"] = this.clientId !== undefined ? this.clientId : <any>null;
        data["clientSecret"] = this.clientSecret !== undefined ? this.clientSecret : <any>null;
        data["redirect"] = this.redirect !== undefined ? this.redirect : <any>null;
        return data; 
    }

    clone(): TradingProvider {
        const json = this.toJSON();
        let result = new TradingProvider();
        result.init(json);
        return result;
    }
}

export interface ITradingProvider {
    providerId?: string | null;
    clientName?: string | null;
    clientId?: string | null;
    clientSecret?: string | null;
    redirect?: string | null;
}

export abstract class MarshalByRefObject implements IMarshalByRefObject {

    constructor(data?: IMarshalByRefObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): MarshalByRefObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): MarshalByRefObject {
        throw new Error("The abstract class 'MarshalByRefObject' cannot be instantiated.");
    }
}

export interface IMarshalByRefObject {
}

export abstract class Stream extends MarshalByRefObject implements IStream {
    canTimeout!: boolean;
    readTimeout!: number;
    writeTimeout!: number;

    constructor(data?: IStream) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.canTimeout = data["canTimeout"] !== undefined ? data["canTimeout"] : <any>null;
            this.readTimeout = data["readTimeout"] !== undefined ? data["readTimeout"] : <any>null;
            this.writeTimeout = data["writeTimeout"] !== undefined ? data["writeTimeout"] : <any>null;
        }
    }

    static fromJS(data: any): Stream {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["canTimeout"] = this.canTimeout !== undefined ? this.canTimeout : <any>null;
        data["readTimeout"] = this.readTimeout !== undefined ? this.readTimeout : <any>null;
        data["writeTimeout"] = this.writeTimeout !== undefined ? this.writeTimeout : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): Stream {
        throw new Error("The abstract class 'Stream' cannot be instantiated.");
    }
}

export interface IStream extends IMarshalByRefObject {
    canTimeout: boolean;
    readTimeout: number;
    writeTimeout: number;
}

export class ReqBaseOfGroupedRq implements IReqBaseOfGroupedRq {

    constructor(data?: IReqBaseOfGroupedRq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ReqBaseOfGroupedRq {
        data = typeof data === 'object' ? data : {};
        let result = new ReqBaseOfGroupedRq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): ReqBaseOfGroupedRq {
        const json = this.toJSON();
        let result = new ReqBaseOfGroupedRq();
        result.init(json);
        return result;
    }
}

export interface IReqBaseOfGroupedRq {
}

export class GroupedRq extends ReqBaseOfGroupedRq implements IGroupedRq {
    data?: HistoricalDataReq[] | null;

    constructor(data?: IGroupedRq) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            if (Array.isArray(data["data"])) {
                this.data = [] as any;
                for (let item of data["data"])
                    this.data!.push(HistoricalDataReq.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GroupedRq {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedRq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        super.toJSON(data);
        return data; 
    }

    clone(): GroupedRq {
        const json = this.toJSON();
        let result = new GroupedRq();
        result.init(json);
        return result;
    }
}

export interface IGroupedRq extends IReqBaseOfGroupedRq {
    data?: HistoricalDataReq[] | null;
}

export class GroupedRqWithSessionKey extends GroupedRq implements IGroupedRqWithSessionKey {
    sessionKey?: string | null;

    constructor(data?: IGroupedRqWithSessionKey) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.sessionKey = data["sessionKey"] !== undefined ? data["sessionKey"] : <any>null;
        }
    }

    static fromJS(data: any): GroupedRqWithSessionKey {
        data = typeof data === 'object' ? data : {};
        let result = new GroupedRqWithSessionKey();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sessionKey"] = this.sessionKey !== undefined ? this.sessionKey : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): GroupedRqWithSessionKey {
        const json = this.toJSON();
        let result = new GroupedRqWithSessionKey();
        result.init(json);
        return result;
    }
}

export interface IGroupedRqWithSessionKey extends IGroupedRq {
    sessionKey?: string | null;
}

export class ReqBaseOfHistoricalDataReq implements IReqBaseOfHistoricalDataReq {

    constructor(data?: IReqBaseOfHistoricalDataReq) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
    }

    static fromJS(data: any): ReqBaseOfHistoricalDataReq {
        data = typeof data === 'object' ? data : {};
        let result = new ReqBaseOfHistoricalDataReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data; 
    }

    clone(): ReqBaseOfHistoricalDataReq {
        const json = this.toJSON();
        let result = new ReqBaseOfHistoricalDataReq();
        result.init(json);
        return result;
    }
}

export interface IReqBaseOfHistoricalDataReq {
}

export class HistoricalDataReq extends ReqBaseOfHistoricalDataReq implements IHistoricalDataReq {
    reqID?: string | null;
    symbol?: string | null;
    period!: number;
    points!: number;

    constructor(data?: IHistoricalDataReq) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.reqID = data["reqID"] !== undefined ? data["reqID"] : <any>null;
            this.symbol = data["symbol"] !== undefined ? data["symbol"] : <any>null;
            this.period = data["period"] !== undefined ? data["period"] : <any>null;
            this.points = data["points"] !== undefined ? data["points"] : <any>null;
        }
    }

    static fromJS(data: any): HistoricalDataReq {
        data = typeof data === 'object' ? data : {};
        let result = new HistoricalDataReq();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reqID"] = this.reqID !== undefined ? this.reqID : <any>null;
        data["symbol"] = this.symbol !== undefined ? this.symbol : <any>null;
        data["period"] = this.period !== undefined ? this.period : <any>null;
        data["points"] = this.points !== undefined ? this.points : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): HistoricalDataReq {
        const json = this.toJSON();
        let result = new HistoricalDataReq();
        result.init(json);
        return result;
    }
}

export interface IHistoricalDataReq extends IReqBaseOfHistoricalDataReq {
    reqID?: string | null;
    symbol?: string | null;
    period: number;
    points: number;
}

export class GainSettingsRs implements IGainSettingsRs {
    gainAppKey?: string | null;
    gainURL?: string | null;

    constructor(data?: IGainSettingsRs) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.gainAppKey = data["gainAppKey"] !== undefined ? data["gainAppKey"] : <any>null;
            this.gainURL = data["gainURL"] !== undefined ? data["gainURL"] : <any>null;
        }
    }

    static fromJS(data: any): GainSettingsRs {
        data = typeof data === 'object' ? data : {};
        let result = new GainSettingsRs();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["gainAppKey"] = this.gainAppKey !== undefined ? this.gainAppKey : <any>null;
        data["gainURL"] = this.gainURL !== undefined ? this.gainURL : <any>null;
        return data; 
    }

    clone(): GainSettingsRs {
        const json = this.toJSON();
        let result = new GainSettingsRs();
        result.init(json);
        return result;
    }
}

export interface IGainSettingsRs {
    gainAppKey?: string | null;
    gainURL?: string | null;
}

export class Setting implements ISetting {
    email?: string | null;
    key?: string | null;
    setting1?: string | null;

    constructor(data?: ISetting) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.key = data["key"] !== undefined ? data["key"] : <any>null;
            this.setting1 = data["setting1"] !== undefined ? data["setting1"] : <any>null;
        }
    }

    static fromJS(data: any): Setting {
        data = typeof data === 'object' ? data : {};
        let result = new Setting();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["key"] = this.key !== undefined ? this.key : <any>null;
        data["setting1"] = this.setting1 !== undefined ? this.setting1 : <any>null;
        return data; 
    }

    clone(): Setting {
        const json = this.toJSON();
        let result = new Setting();
        result.init(json);
        return result;
    }
}

export interface ISetting {
    email?: string | null;
    key?: string | null;
    setting1?: string | null;
}

export class UserTradingProvider implements IUserTradingProvider {
    userProviderId!: number;
    userId!: number;
    providerId?: string | null;
    token?: string | null;
    created!: moment.Moment;
    expires!: moment.Moment;

    constructor(data?: IUserTradingProvider) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.userProviderId = data["userProviderId"] !== undefined ? data["userProviderId"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.providerId = data["providerId"] !== undefined ? data["providerId"] : <any>null;
            this.token = data["token"] !== undefined ? data["token"] : <any>null;
            this.created = data["created"] ? moment(data["created"].toString()) : <any>null;
            this.expires = data["expires"] ? moment(data["expires"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserTradingProvider {
        data = typeof data === 'object' ? data : {};
        let result = new UserTradingProvider();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userProviderId"] = this.userProviderId !== undefined ? this.userProviderId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["providerId"] = this.providerId !== undefined ? this.providerId : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>null;
        return data; 
    }

    clone(): UserTradingProvider {
        const json = this.toJSON();
        let result = new UserTradingProvider();
        result.init(json);
        return result;
    }
}

export interface IUserTradingProvider {
    userProviderId: number;
    userId: number;
    providerId?: string | null;
    token?: string | null;
    created: moment.Moment;
    expires: moment.Moment;
}

export class SharedContent implements ISharedContent {
    uid?: string | null;
    provider?: string | null;
    email?: string | null;
    text?: string | null;
    imageExtension?: string | null;
    created?: moment.Moment | null;
    lastView?: moment.Moment | null;

    constructor(data?: ISharedContent) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.uid = data["uid"] !== undefined ? data["uid"] : <any>null;
            this.provider = data["provider"] !== undefined ? data["provider"] : <any>null;
            this.email = data["email"] !== undefined ? data["email"] : <any>null;
            this.text = data["text"] !== undefined ? data["text"] : <any>null;
            this.imageExtension = data["imageExtension"] !== undefined ? data["imageExtension"] : <any>null;
            this.created = data["created"] ? moment(data["created"].toString()) : <any>null;
            this.lastView = data["lastView"] ? moment(data["lastView"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): SharedContent {
        data = typeof data === 'object' ? data : {};
        let result = new SharedContent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid !== undefined ? this.uid : <any>null;
        data["provider"] = this.provider !== undefined ? this.provider : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["text"] = this.text !== undefined ? this.text : <any>null;
        data["imageExtension"] = this.imageExtension !== undefined ? this.imageExtension : <any>null;
        data["created"] = this.created ? this.created.toISOString() : <any>null;
        data["lastView"] = this.lastView ? this.lastView.toISOString() : <any>null;
        return data; 
    }

    clone(): SharedContent {
        const json = this.toJSON();
        let result = new SharedContent();
        result.init(json);
        return result;
    }
}

export interface ISharedContent {
    uid?: string | null;
    provider?: string | null;
    email?: string | null;
    text?: string | null;
    imageExtension?: string | null;
    created?: moment.Moment | null;
    lastView?: moment.Moment | null;
}

export class TournamentWithAccountId extends Tournament implements ITournamentWithAccountId {
    accountId!: number;
    startDateUtc!: moment.Moment;
    endDateUtc!: moment.Moment;
    startAdvertisingDateUtc!: moment.Moment;
    endAdvertisingDateUtc!: moment.Moment;

    constructor(data?: ITournamentWithAccountId) {
        super(data);
    }

    init(data?: any) {
        super.init(data);
        if (data) {
            this.accountId = data["accountId"] !== undefined ? data["accountId"] : <any>null;
            this.startDateUtc = data["startDateUtc"] ? moment(data["startDateUtc"].toString()) : <any>null;
            this.endDateUtc = data["endDateUtc"] ? moment(data["endDateUtc"].toString()) : <any>null;
            this.startAdvertisingDateUtc = data["startAdvertisingDateUtc"] ? moment(data["startAdvertisingDateUtc"].toString()) : <any>null;
            this.endAdvertisingDateUtc = data["endAdvertisingDateUtc"] ? moment(data["endAdvertisingDateUtc"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): TournamentWithAccountId {
        data = typeof data === 'object' ? data : {};
        let result = new TournamentWithAccountId();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["startDateUtc"] = this.startDateUtc ? this.startDateUtc.toISOString() : <any>null;
        data["endDateUtc"] = this.endDateUtc ? this.endDateUtc.toISOString() : <any>null;
        data["startAdvertisingDateUtc"] = this.startAdvertisingDateUtc ? this.startAdvertisingDateUtc.toISOString() : <any>null;
        data["endAdvertisingDateUtc"] = this.endAdvertisingDateUtc ? this.endAdvertisingDateUtc.toISOString() : <any>null;
        super.toJSON(data);
        return data; 
    }

    clone(): TournamentWithAccountId {
        const json = this.toJSON();
        let result = new TournamentWithAccountId();
        result.init(json);
        return result;
    }
}

export interface ITournamentWithAccountId extends ITournament {
    accountId: number;
    startDateUtc: moment.Moment;
    endDateUtc: moment.Moment;
    startAdvertisingDateUtc: moment.Moment;
    endAdvertisingDateUtc: moment.Moment;
}

export class UserTournamentsResponse implements IUserTournamentsResponse {
    tournamentWithAccount?: TournamentWithAccountId[] | null;
    tournamentWithoutAccount?: TournamentWithAccountId[] | null;

    constructor(data?: IUserTournamentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["tournamentWithAccount"])) {
                this.tournamentWithAccount = [] as any;
                for (let item of data["tournamentWithAccount"])
                    this.tournamentWithAccount!.push(TournamentWithAccountId.fromJS(item));
            }
            if (Array.isArray(data["tournamentWithoutAccount"])) {
                this.tournamentWithoutAccount = [] as any;
                for (let item of data["tournamentWithoutAccount"])
                    this.tournamentWithoutAccount!.push(TournamentWithAccountId.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserTournamentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UserTournamentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tournamentWithAccount)) {
            data["tournamentWithAccount"] = [];
            for (let item of this.tournamentWithAccount)
                data["tournamentWithAccount"].push(item.toJSON());
        }
        if (Array.isArray(this.tournamentWithoutAccount)) {
            data["tournamentWithoutAccount"] = [];
            for (let item of this.tournamentWithoutAccount)
                data["tournamentWithoutAccount"].push(item.toJSON());
        }
        return data; 
    }

    clone(): UserTournamentsResponse {
        const json = this.toJSON();
        let result = new UserTournamentsResponse();
        result.init(json);
        return result;
    }
}

export interface IUserTournamentsResponse {
    tournamentWithAccount?: TournamentWithAccountId[] | null;
    tournamentWithoutAccount?: TournamentWithAccountId[] | null;
}

export class LeaderBoardResponse implements ILeaderBoardResponse {
    leaderBoardForTournament?: Leaderboard[] | null;

    constructor(data?: ILeaderBoardResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            if (Array.isArray(data["leaderBoardForTournament"])) {
                this.leaderBoardForTournament = [] as any;
                for (let item of data["leaderBoardForTournament"])
                    this.leaderBoardForTournament!.push(Leaderboard.fromJS(item));
            }
        }
    }

    static fromJS(data: any): LeaderBoardResponse {
        data = typeof data === 'object' ? data : {};
        let result = new LeaderBoardResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.leaderBoardForTournament)) {
            data["leaderBoardForTournament"] = [];
            for (let item of this.leaderBoardForTournament)
                data["leaderBoardForTournament"].push(item.toJSON());
        }
        return data; 
    }

    clone(): LeaderBoardResponse {
        const json = this.toJSON();
        let result = new LeaderBoardResponse();
        result.init(json);
        return result;
    }
}

export interface ILeaderBoardResponse {
    leaderBoardForTournament?: Leaderboard[] | null;
}

export class Leaderboard implements ILeaderboard {
    tournamentId!: number;
    userId!: number;
    accountId!: number;
    accountName?: string | null;
    balance?: number | null;
    pnL?: number | null;
    place?: number | null;
    isCurrentUser?: boolean | null;

    constructor(data?: ILeaderboard) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(data?: any) {
        if (data) {
            this.tournamentId = data["tournamentId"] !== undefined ? data["tournamentId"] : <any>null;
            this.userId = data["userId"] !== undefined ? data["userId"] : <any>null;
            this.accountId = data["accountId"] !== undefined ? data["accountId"] : <any>null;
            this.accountName = data["accountName"] !== undefined ? data["accountName"] : <any>null;
            this.balance = data["balance"] !== undefined ? data["balance"] : <any>null;
            this.pnL = data["pnL"] !== undefined ? data["pnL"] : <any>null;
            this.place = data["place"] !== undefined ? data["place"] : <any>null;
            this.isCurrentUser = data["isCurrentUser"] !== undefined ? data["isCurrentUser"] : <any>null;
        }
    }

    static fromJS(data: any): Leaderboard {
        data = typeof data === 'object' ? data : {};
        let result = new Leaderboard();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tournamentId"] = this.tournamentId !== undefined ? this.tournamentId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["balance"] = this.balance !== undefined ? this.balance : <any>null;
        data["pnL"] = this.pnL !== undefined ? this.pnL : <any>null;
        data["place"] = this.place !== undefined ? this.place : <any>null;
        data["isCurrentUser"] = this.isCurrentUser !== undefined ? this.isCurrentUser : <any>null;
        return data; 
    }

    clone(): Leaderboard {
        const json = this.toJSON();
        let result = new Leaderboard();
        result.init(json);
        return result;
    }
}

export interface ILeaderboard {
    tournamentId: number;
    userId: number;
    accountId: number;
    accountName?: string | null;
    balance?: number | null;
    pnL?: number | null;
    place?: number | null;
    isCurrentUser?: boolean | null;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number; 
    response: string; 
    headers: { [key: string]: any; };
    result: any; 

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if(result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader(); 
            reader.onload = event => { 
                observer.next((<any>event.target).result);
                observer.complete();
            };
            reader.readAsText(blob); 
        }
    });
}